import { Card, Col, Row, Select, Typography, message, Table, Tag, Flex, List, Avatar, Skeleton, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import axiosClient from "../../../Authentication/ApiCall";
import ReactApexChart from "react-apexcharts";
import useInterval from "use-interval";
import "../../../../font/Helvetica.ttf";
import _, { map } from "lodash";
import Chart from "react-apexcharts";
import { GiCctvCamera, GiFootsteps, GiTeamUpgrade } from "react-icons/gi";
import { ImHourGlass } from "react-icons/im";
import socket from "../../../../Socket";
import authService from "../../../Authentication/authService";
import { FaCameraRetro, FaRegDotCircle } from "react-icons/fa";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip as Tool, Legend } from 'chart.js';
import moment from "moment";

const { Title, Text } = Typography;
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tool,
  Legend
);

let RenderComp = {
  IngressEgress: false,
  DwellFootfall: false,
  EngagedBounced: false,
  AgeGender: false,
  PeakHours: false,
};

let IngressEgressDetails = {
  SelectedDate: "",
  ContinueFetch: true,
};

const useExactInterval_Footfall = (callback) => {
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const getNextIntervalTime_Footfall = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const nextMinutes = Math.ceil(minutes / 2) * 2;
      const nextRun = new Date(now);
      nextRun.setMinutes(nextMinutes);
      nextRun.setSeconds(0);
      nextRun.setMilliseconds(0);

      if (nextRun <= now) {
        nextRun.setMinutes(nextRun.getMinutes() + 2);
      }

      return nextRun - now;
    };

    timeoutRef.current = setTimeout(() => {
      callback();
      intervalRef.current = setInterval(callback, 2 * 60 * 1000);
    }, getNextIntervalTime_Footfall());

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [callback]);
};

const useExactInterval_Dwell = (callback) => {
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const getNextIntervalTime_Dwell = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const nextMinutes = Math.ceil(minutes / 5) * 5;
      const nextRun = new Date(now);
      nextRun.setMinutes(nextMinutes);
      nextRun.setSeconds(0);
      nextRun.setMilliseconds(0);

      if (nextRun <= now) {
        nextRun.setMinutes(nextRun.getMinutes() + 5);
      }

      return nextRun - now;
    };

    timeoutRef.current = setTimeout(() => {
      callback();
      intervalRef.current = setInterval(callback, 5 * 60 * 1000);
    }, getNextIntervalTime_Dwell());

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [callback]);
};

const useExactInterval_Crowd = (callback) => {
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const getNextIntervalTime_Crowd = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const nextMinutes = Math.ceil(minutes / 3) * 3;
      const nextRun = new Date(now);
      nextRun.setMinutes(nextMinutes);
      nextRun.setSeconds(0);
      nextRun.setMilliseconds(0);

      if (nextRun <= now) {
        nextRun.setMinutes(nextRun.getMinutes() + 3);
      }

      return nextRun - now;
    };

    timeoutRef.current = setTimeout(() => {
      callback();
      intervalRef.current = setInterval(callback, 3 * 60 * 1000);
    }, getNextIntervalTime_Crowd());

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [callback]);
};

// let FootfallDirectionHourlyDetails = {
//   camlist: [],
//   selectedcam: "",
//   selectedcamName: "",
//   selectedDate: dayjs().format("YYYY-MM-DD"),
//   DataOfDate: "",
//   DirectionImage: null,
//   DirectionData: [],
//   loading: false,
//   Hour: dayjs().hour(),
// };

// let EngageAndBounceHourlyDetails = {
//   camlist: [],
//   selectedcam: null,
//   selectedDate: dayjs().format("YYYY-MM-DD"),
//   DataOfDate: null,
// };

const Live = (props) => {
  const [RenderCompController, setRenderCompController] = useState(RenderComp);
  const [HandleDateForIngressEgress, setHandleDateForIngressEgress] = useState(IngressEgressDetails);
  const [totalingress, settotalingress] = useState();
  // const [PasserTableValue, setPasserTableValue] = useState("");
  const [totalingrespercentage, settotalingresspercentage] = useState(0);
  const [ingressloading, setingressloading] = useState(true);
  // const [menuOptions, setMenuOptions] = useState([]);
  const { Option } = Select;
  const [PasserByCount, setPasserByCount] = useState([]);
  const [peakHour, setpeakHour] = useState();
  const [yesterdaypeakHour, setyesterdaypeakHour] = useState();
  const [data, setdata] = useState([]);
  const [totalfootfallactivecamera, settotalfootfallactivecamera] = useState(0);
  const [eventbasedactivecamera, seteventbasedactivecamera] = useState(0);
  const [totalCrowdAnalysisCount, setTotalCrowdAnalysisCount] = useState(0);
  const [totalLiveOccupancyCount, setTotalLiveOccupancyCount] = useState(0);
  const [storesLive, setStoresLive] = useState(false);
  const [ingressLive, setIngressLive] = useState(false);
  const [dwellLive, setDwellLive] = useState(false);
  const [storesFootfallDwell, setStoresFootfallDwell] = useState([]);
  const [storeslist, setstoreslist] = useState([]);
  const [selectedstoresIds, setselectedstoresIds] = useState([]);
  const [selectedstoresList, setselectedstoresList] = useState([]);
  const [selectedstores, setselectedstores] = useState({});
  const [ingresscameras, setingresscameras] = useState(0);
  const [dwellcameras, setdwellcameras] = useState(0);
  const [storeingresscameras, setstoreingresscameras] = useState(0);
  // const [FootfallDirectionHourlyController,setFootfallDirectionHourlyController,] = useState(FootfallDirectionHourlyDetails);
  // const [EngageBounceHourController, setEngageBounceHourController] = useState( EngageAndBounceHourlyDetails);
    //const [graphLoading, setGraphLoading] = useState(false);
  var footfall_socketcheck = false
  var dwell_socketcheck = false
  var crowd_socketcheck = false


  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-bar",
        animations: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        contextmenu: {
          enabled: false,
        },
        zoom: {
          enabled: false, // Ensure zoom is disabled
        },
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      xaxis: {
        type: "category", // Change type to category for categorical data
        categories: [], // Initialize categories as empty array
        title: {
          text: "Hour",
          offsetY: -10,
        },
      },
      yaxis: {
        type: "Count",
        title: {
          text: "Count",
          offsetY: -10,
        },
        labels: {
          formatter: function (value) {
            return parseInt(value); // Convert the y-axis values to decimal format
          },
        },
      },
      colors: ["#00e396", "#008ffb"],
      dataLabels: {
        enabled: false,
        offsetY: -15,
        style: {
          colors: ["#615494", "#f27777"],
        },
      },
      stroke: {
        width: 1,
      },
      pattern: {
        strokeWidth: 0.1,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top",
            offsetY: -20,
            width: 1,
            style: {
              fontSize: "12px",
              colors: [" #000"],
              offsetY: -20,
            },
          },
        },
        dataLabels: {
          enabled: true,
          hideOverflowingLabels: true,
          formatter: function () {
            return 25;
          },
          offsetY: -20,
        },
      },
    },
    series: [
      {
        name: "Ingress",
        data: [],
      },
      // {
      //   name: "Egress",
      //   data: [],
      // },
    ],
  });

  const [EngagechartData, setEngageChartData] = useState({
    options: {
      chart: {
        id: "basic-bar",
        animations: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        contextmenu: {
          enabled: false,
        },
        zoom: {
          enabled: false, // Ensure zoom is disabled
        },
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      xaxis: {
        type: "category", // Change type to category for categorical data
        categories: [], // Initialize categories as empty array
        title: {
          text: "Hour",
          offsetY: -10,
        },
      },
      yaxis: {
        type: "Count",
        title: {
          text: "Count",
          offsetY: -10,
        },
        labels: {
          formatter: function (value) {
            return parseInt(value); // Convert the y-axis values to decimal format
          },
        },
      },
      colors: ["#00e396", "#008ffb"],
      dataLabels: {
        enabled: false,
        offsetY: -15,
        style: {
          colors: ["#615494", "#f27777"],
        },
      },
      stroke: {
        width: 1,
      },
      pattern: {
        strokeWidth: 0.1,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top",
            offsetY: -20,
            width: 1,
            style: {
              fontSize: "12px",
              colors: [" #000"],
              offsetY: -20,
            },
          },
        },
        dataLabels: {
          enabled: true,
          hideOverflowingLabels: true,
          formatter: function () {
            return 25;
          },
          offsetY: -20,
        },
      },
      title: {
        text: "Engaged",
        align: "center",
        margin: 10,
        style: {
          fontSize: "16px",
          fontFamily: "Helvetica",
        },
      },
    },
    series: [
      {
        name: "Engaged",
        data: [],
      },
    ],
  });

  const [BouncechartData, setBounceChartData] = useState({
    options: {
      chart: {
        id: "basic-bar",
        animations: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        contextmenu: {
          enabled: false,
        },
        zoom: {
          enabled: false, // Ensure zoom is disabled
        },
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      xaxis: {
        type: "category", // Change type to category for categorical data
        categories: [], // Initialize categories as empty array
        title: {
          text: "Hour",
          offsetY: -10,
        },
      },
      yaxis: {
        type: "Count",
        title: {
          text: "Count",
          offsetY: -10,
        },
        labels: {
          formatter: function (value) {
            return parseInt(value); // Convert the y-axis values to decimal format
          },
        },
      },
      colors: ["#00e396", "#008ffb"],
      dataLabels: {
        enabled: false,
        offsetY: -15,
        style: {
          colors: ["#615494", "#f27777"],
        },
      },
      stroke: {
        width: 1,
      },
      pattern: {
        strokeWidth: 0.1,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top",
            offsetY: -20,
            width: 1,
            style: {
              fontSize: "12px",
              colors: [" #000"],
              offsetY: -20,
            },
          },
        },
        dataLabels: {
          enabled: true,
          hideOverflowingLabels: true,
          formatter: function () {
            return 25;
          },
          offsetY: -20,
        },
      },
      title: {
        text: "Bounced",
        align: "center",
        margin: 10,
        style: {
          fontSize: "16px",
          fontFamily: "Helvetica",
        },
      },
    },
    series: [
      {
        name: "Bounced",
        data: [],
      },
    ],
  });

  const [DwellBarData, setDwellBarData] = useState({
    options: {
      // chart: {
      //   height: 350,
      //   type: "bar",
      //   zoom: {
      //     enabled: false,
      //   },
      // },
      chart: {
        id: "basic-bar",
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: { show: false },
        contextmenu: { enabled: false },
        animations: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },

      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        title: { text: "Hour ", offsetY: -10 },
      },
      yaxis: {
        title: { text: "Count" },
        // labels: {
        //   formatter: function (val) {
        //     return val.toFixed() // Formats Y-axis labels to two decimal places
        //   },
        // },
      },
      // title: {
      //   text: "Avg Dwell Time",
      //   align: "center",
      //   margin: 10,
      //   style: {
      //     fontSize: "16px",
      //     fontFamily: "Helvetica",
      //   },
      // },
    },
    series: [],
  });

  const [EntryWiseBarData, setEntryWiseBarData] = useState({
    options: {
      // chart: {
      //   height: 350,
      //   type: "bar",
      //   zoom: {
      //     enabled: false,
      //   },
      // },
      chart: {
        id: "basic-bar",
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: { show: false },
        contextmenu: { enabled: false },
        animations: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },

      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        title: { text: "Camera Name ", offsetY: -10 },
      },
      yaxis: {
        title: { text: "Count" },
      },
      // title: {
      //   text: "Entry Wise FootFall",
      //   align: "center",
      //   style: {
      //     fontSize: "16px",
      //     fontFamily: "Helvetica",
      //   },
      // },
    },
    series: [],
  });

  const [EngageBounceWiseBarData, setEngageBounceWiseBarData] = useState({
    graph: {
      series: [
        {
          name: "Engaged",
          data: [],
        },
        {
          name: "Bounced",
          data: [],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        colors: ["#82da2a", "#f14624"], 
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "85%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: (val) => `${val}`,
          },
        },
      },
    },
  });

  // const [Engagersweeklychart, setEngagersweeklychart] = useState({
  //   options: {
  //     // chart: {
  //     //   height: 350,
  //     //   type: "bar",
  //     //   zoom: {
  //     //     enabled: false,
  //     //   },
  //     // },
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       height: 350,
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //       animations: {
  //         enabled: false,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //       },
  //     },

  //     grid: {
  //       row: {
  //         colors: ["#f3f3f3", "transparent"],
  //         opacity: 0.5,
  //       },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Date ", offsetY: -10 },
  //     },
  //     yaxis: {
  //       title: { text: "Count" },
  //       // labels: {
  //       //   formatter: function (val) {
  //       //     return val.toFixed() // Formats Y-axis labels to two decimal places
  //       //   },
  //       // },
  //     },
  //     title: {
  //       text: "Engaged",
  //       align: "center",
  //       margin: 10,
  //       style: {
  //         fontSize: "16px",
  //         fontFamily: "Helvetica",
  //       },
  //     },
  //   },
  //   series: [],
  // });

  // const [Bouncedweeklychart, setBouncedweeklychart] = useState({
  //   options: {
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       height: 350,
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //       animations: {
  //         enabled: false,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //       },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Date ", offsetY: -10 },
  //     },
  //     yaxis: { title: { text: "Count" } },
  //     grid: {
  //       row: {
  //         colors: ["#f3f3f3", "transparent"],
  //         opacity: 0.5,
  //       },
  //     },

  //     colors: ["#00e396"],
  //     title: {
  //       text: "Bounced",
  //       align: "center",
  //       margin: 10,
  //       style: {
  //         fontSize: "16px",
  //         fontFamily: "Helvetica",
  //       },
  //     },
  //   },
  //   series: [
  //     {
  //       name: "Bounced",
  //       data: [],
  //       // data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
  //     },
  //   ],
  // });

  // const [DwellHourlyDateWise, setDwellHourlyDateWise] = useState({
  //   options: {
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //       animations: {
  //         enabled: false,
  //       },
  //     },
  //     plotOptions: {
  //       bar: { horizontal: false },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Date", offsetY: -10 },
  //     },
  //     yaxis: { title: { text: "Seconds" } },
  //     legend: {
  //       position: "top",
  //       horizontalAlign: "center",
  //       offsetX: 0,
  //     },
  //     colors: [
  //       "#00e396",
  //       "#feb019",
  //       "#ff4560",
  //       "#775dd0",
  //       "#008ffb",
  //       "#00d9e9",
  //       "#ff9f00",
  //     ],
  //     tooltip: {
  //       enabled: true,
  //       y: {
  //         formatter: function (val) {
  //           return val + " sec";
  //         },
  //       },
  //     },
  //   },
  //   series: [],
  //   cameraList: [],
  //   selectedCam: null,
  // });

  const transformData1 = (data, zoneNames) => {
    const hours = _.map(data, "createdDate");
    const series = _.map(zoneNames, (zone) => {
      const DwellTime_avg = _.map(data, zone + ".average_dwell_time");
      const Final_Dwell = DwellTime_avg.map((item) => Math.round(item));
      return {
        name: zone,
        data: Final_Dwell,
      };
    });

    return { hours, series };
  };

  const extractZoneNames1 = (data) => {
    return _(data)
      .flatMap(_.keys)
      .filter((key) => key.startsWith("area"))
      .uniq()
      .value();
  };

  // const updateCameraList = (CameraList) => {
  //   if (CameraList) {
  //     // const newCamList = CameraList.map((item) => ({
  //     //   value: item.cameraId,
  //     //   label: item.cameraName,
  //     // }));
  //     // setDwellHourly((prev) => ({
  //     //   ...prev,
  //     //   cameraList: [...newCamList],
  //     // }));
  //     // setDwellHourlyDateWise((prev) => ({
  //     //   ...prev,
  //     //   cameraList: [...newCamList],
  //     // }));
  //   }
  // };

  // //onclick of menu item call api
  // const handleSelectChange = (value) => {
  //   const selectedOption = menuOptions.find((option) => option.id === value);
  //   axiosClient
  //     .get("/livereport/getingressegress?id=" + selectedOption.id)
  //     .then((response) => {
  //       if (response.data.issuccess === true) {
  //         setingressloading(false);

  //         const list_hour = map(
  //           response.data.data.total_records_hour, 
  //           "hour"
  //         );

  //         const list_ingress = map(
  //           response.data.data.total_records_hour,
  //           "totalingress"
  //         );
  //         const list_egress = map(
  //           response.data.data.total_records_hour,
  //           "totalegress"
  //         );

  //         setChartData((prev) => ({
  //           ...prev,
  //           options: {
  //             ...prev.options,
  //             xaxis: {
  //               // ...prev.options.xaxis,
  //               categories: list_hour,
  //             },
  //           },
  //           series: [
  //             {
  //               name: "Ingress",
  //               data: list_ingress,
  //             },
  //             {
  //               name: "Egress",
  //               data: list_egress,
  //             },
  //           ],
  //         }));
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // };

  // const FetchDataForCrowdAnalysis = async () => {
  //   try {
  //     await axiosClient
  //       .get(`crowdAnalysis/getCrowdAnalysisDetails?floorId=${props.props[0] ? props.props[0].id : null}&zoneId=${props.props[1] ? props.props[1].id : null}&zonecameraIds=${props.props[1] ? props.props[1].cameraIds : null}`)
  //       .then((response) => {
  //         if (response.data.issuccess === true) {
  //           setTotalCrowdAnalysisCount(response.data.data.map((item) => item.count).reduce((acc, num) => acc + num, 0))
  //           setdata(response.data.data);
  //         }
  //       })
  //       .catch((err) => {
  //         if (err.status === 0) {
  //           message.error("Server error");
  //         } else {
  //           message.error(err.message);
  //         }
  //       });
  //   } catch (err) {
  //   }
  // };

  // const [DwellHourly, setDwellHourly] = useState({
  //   options: {
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //       animations: {
  //         enabled: false,
  //       },
  //     },
  //     plotOptions: {
  //       bar: { horizontal: false },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Hour ", offsetY: -10 },
  //     },
  //     yaxis: { title: { text: "Seconds" } },
  //     legend: {
  //       position: "top",
  //       horizontalAlign: "center",
  //       offsetX: 0,
  //     },
  //     colors: [
  //       "#00e396",
  //       "#feb019",
  //       "#ff4560",
  //       "#775dd0",
  //       "#008ffb",
  //       "#00d9e9",
  //       "#ff9f00",
  //     ],
  //     tooltip: {
  //       enabled: true,
  //       y: {
  //         formatter: function (val) {
  //           return val + " sec";
  //         },
  //       },
  //     },
  //   },
  //   series: [],
  // });

  //ingress and passer by graph
  // const [passerby, setPasserby] = useState({
  //   series: [
  //     {
  //       name: "Passer By",
  //       data: [],
  //     },
  //     {
  //       name: "Ingress",
  //       data: [],
  //     },
  //   ],
  //   options: {
  //     chart: {
  //       type: "bar",
  //       height: 150,
  //       stacked: true,
  //       stackType: "100%",
  //       toolbar: {
  //         show: false, // Disable the toolbar
  //       },
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: true,
  //         barHeight: "100%",
  //       },
  //     },

  //     xaxis: {
  //       categories: ["Passer By and Ingress"],
  //       labels: {
  //         show: false,
  //       },
  //       axisBorder: {
  //         show: false,
  //       },
  //       axisTicks: {
  //         show: false,
  //       },
  //     },
  //     yaxis: {
  //       show: false,
  //     },
  //     fill: {
  //       opacity: 1,
  //       //colors: ['#1E90FF', '#FFD700'] // Define colors for each segment
  //     },
  //     legend: {
  //       show: true,
  //     },
  //     title: {
  //       text: "", // Add the title here
  //       align: "center", // Align the title to the center
  //       style: {
  //         fontSize: "20px",
  //         fontWeight: "bold",
  //         color: "#263238",
  //       },
  //     },
  //   },
  // });

  // const [EngagedHourlyChart, setEngagedHourlyChart] = useState({
  //   options: {
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //     },
  //     plotOptions: {
  //       bar: { horizontal: false },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Hour ", offsetY: -10 },
  //     },
  //     yaxis: { title: { text: "Count" } },
  //     legend: {
  //       position: "top",
  //       horizontalAlign: "center",
  //       offsetX: 0,
  //     },
  //     colors: [
  //       "#00e396",
  //       "#feb019",
  //       "#ff4560",
  //       "#775dd0",
  //       "#008ffb",
  //       "#00d9e9",
  //       "#ff9f00",
  //     ],
  //   },
  //   series: [],
  // });

  // const [BouncedHourlyChart, setBouncedHourlyChart] = useState({
  //   options: {
  //     chart: {
  //       id: "basic-bar",
  //       type: "bar",
  //       stacked: true,
  //       toolbar: { show: false },
  //       contextmenu: { enabled: false },
  //     },
  //     plotOptions: {
  //       bar: { horizontal: false },
  //     },
  //     xaxis: {
  //       categories: [],
  //       title: { text: "Hour ", offsetY: -10 },
  //     },
  //     yaxis: { title: { text: "Count" } },
  //     legend: {
  //       position: "top",
  //       horizontalAlign: "center",
  //       offsetX: 0,
  //     },
  //     colors: [
  //       "#00e396",
  //       "#feb019",
  //       "#ff4560",
  //       "#775dd0",
  //       "#008ffb",
  //       "#00d9e9",
  //       "#ff9f00",
  //     ],
  //   },
  //   series: [],
  // });

  // const [DwellHourlyController, setDwellHourlyController] = useState({
  //   camlist: [],
  //   selectedcam: null,
  //   selectedDate: dayjs().format("YYYY-MM-DD"),
  //   DataOfDate: null,
  //   selectedcameraname: null,
  // });

  // const EngageAndBounceHourly = () => {
  //   return (
  //     <Col
  //       xs={{ span: 24 / 1, offset: 0 }}
  //       sm={{ span: 24 / 1, offset: 0 }}
  //       md={{ span: 24 / 1, offset: 0 }}
  //       lg={{ span: 24 / 1, offset: 0 }}
  //       xl={{ span: 24 / 1, offset: 0 }}
  //     >
  //       <Card
  //         style={{
  //           userSelect: "none",
  //           boxShadow: "none",
  //         }}
  //         title={
  //           <>
  //             <Row justify={"space-between"} align={"middle"}>
  //               <Col>
  //                 <Flex align="center" gap={10}>
  //                   <Title
  //                     level={5}
  //                     type="secondary"
  //                     style={{ fontFamily: "Helvetica" }}
  //                   >
  //                     Hourly Engaged and Bounced
  //                   </Title>
  //                   {/* <Tag>
  //                     {EngageBounceHourController.DataOfDate &&
  //                       EngageBounceHourController.DataOfDate}
  //                   </Tag> */}
  //                 </Flex>
  //               </Col>
  //               <Col>
  //                 <Row align="center" gutter={[10, 0]}>
  //                   <Col>
  //                     {/* <DatePicker
  //                       onChange={onChangeDateEngageAndBounceHourly}
  //                       format={"YYYY-MM-DD"}
  //                       disabledDate={(current) => {
  //                         return current && current > moment().endOf("day");
  //                       }}
  //                       defaultValue={dayjs(
  //                         EngageBounceHourController.DataOfDate
  //                           ? EngageBounceHourController.DataOfDate
  //                           : EngageBounceHourController.selectedDate
  //                       )}
  //                     /> */}
  //                   </Col>
  //                   <Col>
  //                     <Select
  //                       onChange={OnChangeCameraSelectEngageAndBounceHourly}
  //                       placeholder={<Text type="secondary">Camera</Text>}
  //                       value={EngageBounceHourController.selectedcam}
  //                       defaultValue={EngageBounceHourController.selectedcam}
  //                       style={{
  //                         width: 120,
  //                       }}
  //                       options={EngageBounceHourController.camlist}
  //                     />
  //                   </Col>
  //                 </Row>
  //               </Col>
  //             </Row>
  //           </>
  //         }
  //       >
  //         <Row gutter={[1, 10]} justify={"space-between"} align={"middle"}>
  //           <Col
  //             xs={{ span: 23 / 1, offset: 0 }}
  //             sm={{ span: 24 / 1, offset: 0 }}
  //             md={{ span: 11 / 1, offset: 0 }}
  //             lg={{ span: 11 / 1, offset: 0 }}
  //             xl={{ span: 11, offset: 0 }}
  //           >
  //             <div style={{ height: "250px" }}>
  //               <ReactApexChart
  //                 type="bar"
  //                 options={EngagedHourlyChart.options}
  //                 series={EngagedHourlyChart.series}
  //                 height="100%"
  //                 key={EngagedHourlyChart.series}
  //               />
  //             </div>
  //           </Col>
  //           <Divider type="vertical" style={{ height: "250px" }} />
  //           <Col
  //             xs={{ span: 24 / 1, offset: 0 }}
  //             sm={{ span: 24 / 1, offset: 0 }}
  //             md={{ span: 11 / 1, offset: 0 }}
  //             lg={{ span: 11 / 1, offset: 0 }}
  //             xl={{ span: 11, offset: 0 }}
  //           >
  //             <div style={{ height: "250px" }}>
  //               <ReactApexChart
  //                 type="bar"
  //                 options={BouncedHourlyChart.options}
  //                 series={BouncedHourlyChart.series}
  //                 height="100%"
  //                 key={BouncedHourlyChart.series}
  //               />
  //             </div>
  //           </Col>
  //         </Row>
  //       </Card>
  //     </Col>
  //   );
  // };

  // const OnChangeCameraSelectEngageAndBounceHourly = (selectedcam) => {
  //   if (selectedcam !== null && selectedcam !== undefined) {
  //     setEngageBounceHourController((prev) => ({ ...prev, selectedcam }));
  //   }
  // };

  // // Onchange date function for engaged and bouncee hourly
  // const onChangeDateEngageAndBounceHourly = (date, dateString) => {
  //   const datefrom_picker = moment(dateString, "YYYY-MM-DD");
  //   if (datefrom_picker._isValid) {
  //     setEngageBounceHourController((prev) => ({
  //       ...prev,
  //       selectedDate: dateString,
  //       selectedcam: null,
  //     }));
  //   }
  // };

  // const transformDataEngageAndBounce = (data, zoneNames) => {
  //   const hours = _.map(data, "hour");

  //   const seriesEngage = _.map(zoneNames, (zone) => {
  //     const Engage_avg = _.map(data, zone + ".engaged");
  //     const Final_Engage = Engage_avg.map((item) => Math.round(item));
  //     return {
  //       name: zone,
  //       data: Final_Engage,
  //     };
  //   });

  //   const seriesBounce = _.map(zoneNames, (zone) => {
  //     const Bounce_avg = _.map(data, zone + ".bounced");
  //     const Final_Bounce = Bounce_avg.map((item) => Math.round(item));
  //     return {
  //       name: zone,
  //       data: Final_Bounce,
  //     };
  //   });

  //   return { hours, seriesEngage, seriesBounce };
  // };

  // const extractZoneNames = (data) => {
  //   return _(data)
  //     .flatMap(_.keys)
  //     .filter((key) => key.startsWith("Area"))
  //     .uniq()
  //     .value();
  // };

  // const transformData = (data, zoneNames) => {
  //   const hours = _.map(data, "hour");
  //   const series = _.map(zoneNames, (zone) => {
  //     const DwellTime_avg = _.map(data, zone + ".average_dwell_time");
  //     const Final_Dwell = DwellTime_avg.map((item) => Math.round(item));
  //     return {
  //       name: zone,
  //       data: Final_Dwell,
  //     };
  //   });
  //   return { hours, series };
  // };

  // function getOverallPasserByCount() {
  //   axiosClient
  //     .get("/livereport/getoverallpasserbycount")
  //     .then((response) => {
  //       if (response.data.issuccess === true) {        
  //         const data = response?.data?.data?.data[0]; // Assuming there's only one object in the array
  //         const passerbyCount =
  //           data.passerby === null || data.passerby === undefined
  //             ? 0
  //             : parseInt(data.passerby);
  //         const ingressCount =
  //           data.ingress === null || data.ingress === undefined
  //             ? 0
  //             : parseInt(data.ingress);

  //         const updatedSeries = [
  //           {
  //             name: "Passer By",
  //             data: [passerbyCount],
  //           },
  //           {
  //             name: "Ingress",
  //             data: [ingressCount],
  //           },
  //         ];

  //         const updatedOptions = {
  //           ...passerby.options,
  //           title: {
  //             ...passerby.options.title,
  //             text: `Total: ${passerbyCount + ingressCount}`,
  //           },
  //         };

  //         setPasserby({ series: updatedSeries, options: updatedOptions });
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // }

  // function getPasserByCount() {
  //   axiosClient
  //     .get("/livereport/getpasserbycount?camId=&date=")
  //     .then((response) => {
  //       if (response.data.issuccess === true) {
  //         // const updatedData = response.data.data.data
  //         //   .filter((item) => item.hour >= 7)
  //         //   .sort((a, b) => b.hour - a.hour) // Sort by hour in descending order
  //         //   .map((item) => ({
  //         //     hour: moment(item.hour, "HH").format("h A"),
  //         //     passerby: item.passerby || 0, // Set passerby to 0 if null, undefined, or empty
  //         //     ingress: item.ingress || 0, // Set ingress to 0 if null, undefined, or empty
  //         //   }))
  //         // setPasserTableValue(updatedData)
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // }

  // const PasserByNew = () => {
  //   axiosClient
  //     .get(
  //       `/livereport/getpasserbydetails?startDate=${dayjs().format(
  //         "YYYY-MM-DD"
  //       )}&endDate=${dayjs().format("YYYY-MM-DD")}&cameraId=`
  //     )
  //     .then((response) => {
  //       if (response.data.issuccess === true) {
  //         setPasserByCount(response.data.data);
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // };

  //passer table column  ingressCount
  // const PasserColumn = [
  //   {
  //     title: "Camera name",
  //     dataIndex: "cameraName",
  //     key: "cameraName",
  //     render: (text) => <span style={{ color: "black" }}>{text}</span>,
  //     align: "center",
  //   },
  //   {
  //     title: "Store",
  //     dataIndex: "location",
  //     key: "location",
  //     render: (text) => <span style={{ color: "black" }}>{text}</span>,
  //     align: "center",
  //   },
  //   {
  //     title: "Ingress count",
  //     dataIndex: "ingressCount",
  //     key: "ingressCount",
  //     render: (text) => <span style={{ color: "black" }}>{text}</span>,
  //     align: "center",
  //   },
  //   {
  //     title: "Passer by count",
  //     dataIndex: "passerByCount",
  //     key: "passerByCount",
  //     render: (text) => <span style={{ color: "black" }}>{text}</span>,
  //     align: "center",
  //   },
  // ];

  // const paginationConfig = {
  //   pageSize: 4,
  //   responsive: true,
  // };

  // const tableContainerStyle = {
  //   //overflowX: "auto",
  //   // maxWidth: "100%",
  //   width: "100%",
  //   height: window.innerWidth > 850 ? "22.5rem" : "auto",
  // };

  // Live tag for design
  const LiveTag = () => (
    <Tag color="green">
      <Flex gap={3} align="center">
        <Text
          style={{
            margin: "0px",
            fontSize: "13px",
            fontWeight: "initial",
          }}
        >
          Live
        </Text>
        <FaRegDotCircle />
      </Flex>
    </Tag>
  );

  useEffect(() => {
    setTimeout(() => {
      setRenderCompController((prev) => ({ ...prev, IngressEgress: true }));
    }, 10);

    setTimeout(() => {
      setRenderCompController((prev) => ({ ...prev, DwellFootfall: true }));
    }, 10);
    setTimeout(() => {
      setRenderCompController((prev) => ({ ...prev, EngagedBounced: true }));
    }, 10);

    setTimeout(() => {
      setRenderCompController((prev) => ({ ...prev, AgeGender: true }));
    }, 10);
    setTimeout(() => {
      setRenderCompController((prev) => ({ ...prev, PeakHours: true }));
    }, 10);
  }, []);

  // useInterval(async () => {
  //   //getPasserByCount();
  //   getOverallPasserByCount();
  //   if (HandleDateForIngressEgress.ContinueFetch === true) {
  //     await axiosClient
  //       .get(`/livereport/getingressegress?date&camid=`)
  //       .then((response) => {    
  //         if (response.data.issuccess === true) {
  //           setingressloading(false);
  //           settotalingress(response.data.data.total_ingress_egress);
  //           settotalingresspercentage(
  //             response.data.data.percentage_ingress_basedOnTime
  //           );
  //           const list_hour = map(
  //             response.data.data.total_records_hour,
  //             "hour"
  //           );

  //           const list_ingress = map(
  //             response.data.data.total_records_hour,
  //             "totalingress"
  //           );
  //           const list_egress = map(
  //             response.data.data.total_records_hour,
  //             "totalegress"
  //           );
  //           setChartData((prev) => ({
  //             ...prev,
  //             options: {
  //               ...prev.options,
  //               xaxis: {
  //                 // ...prev.options.xaxis,
  //                 categories: list_hour,
  //               },
  //             },
  //             series: [
  //               {
  //                 name: "Ingress",
  //                 data: list_ingress,
  //               },
  //               {
  //                 name: "Egress",
  //                 data: list_egress,
  //               },
  //             ],
  //           }));
  //         }
  //       })
  //       .catch((err) => {
  //         if (err.status === 0) {
  //           message.error("Network error");
  //         } else {
  //           message.error(err.message);
  //         }
  //       });
  //   }  
  // }, 120000);

  // useInterval(async () => {
  //   if(ingressLive)
  //   {
  //     const req = {
  //       headers: { authorization: authService.getCurrentUser() },
  //       query: {
  //         date: "",
  //         camid: "",
  //         floorId: props.props[0] ? props.props[0].id : null,
  //         startDate: moment().format("YYYY-MM-DD"),
  //         endDate: moment().format("YYYY-MM-DD"),
  //         zoneId: props.props[1] ? props.props[1].id : null,
  //         zonecameraIds: props.props[1] ? props.props[1].cameraIds : null,
  //         storesId: props.props[2] ? props.props[2].id : null,
  //         storescameraIds: props.props[2] ? props.props[2].cameraIds : null,
  //       },
  //     };
  //     footfall_socketcheck = true
  //     socket.emit("Foot_Fall", req)
  //   }
   
  // }, 60000);


  useExactInterval_Footfall(async () => {
    if ((ingressLive && footfall_socketcheck === false) || (props.props[2] && storesLive && ingressLive === false && dwellLive === false && footfall_socketcheck === false)) {
      const req = {
        headers: { authorization: authService.getCurrentUser() },
        query: {
          date: "",
          camid: "",
          floorId: props.props[0] ? props.props[0].id : null,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          zoneId: props.props[1] ? props.props[1].id : null,
          zonecameraIds: props.props[1] ? props.props[1].cameraIds : null,
          storesId: Object.keys(selectedstores).length > 0 ? selectedstores.storesId : null,
          storescameraIds: Object.keys(selectedstores).length > 0 ? selectedstores.cameraIds : null, 
          storeId: props.props[2] && storesLive === true && ingressLive === false && dwellLive === false ? props.props[2][0].storeId : null
        },
      };      
      if(footfall_socketcheck === false)
      {
        footfall_socketcheck = true
        socket.emit("Foot_Fall", req) 
      }             
    }
  });

  socket.on("Foot_fall", (data) => {
    if (footfall_socketcheck === true) {
      footfall_socketcheck = false
      if (HandleDateForIngressEgress.ContinueFetch === true) {
        if (data.ingressegress != null) {
          setingressloading(false);
          settotalingress(data.ingressegress.total_ingress_egress);
          settotalingresspercentage(data.ingressegress.percentage_ingress_basedOnTime);
          setpeakHour(data.ingressegress.currentPeakHourRange);
          setyesterdaypeakHour(data.ingressegress.yesterdayPeakHourRange);
          setPasserByCount(data.ingressegress.passerByLists);
          const list_hour = map(
            data.ingressegress.total_records_hour,
            "hour"
          );
          const list_ingress = map(
            data.ingressegress.total_records_hour,
            "totalingress"
          );
          // const list_egress = map(
          //   data.ingressegress.total_records_hour,
          //   "totalegress"
          // );
          setChartData((prev) => ({
            ...prev,
            options: {
              ...prev.options,
              xaxis: {
                // ...prev.options.xaxis,
                categories: list_hour,
                title: {
                  text: "Hour",
                  offsetY: -10,
                },
              },
            },
            series: [
              {
                name: "Ingress",
                data: list_ingress,
              },
              // {
              //   name: "Egress",
              //   data: list_egress,
              // },
            ],
          }));

          const list_cameraName = map(data.ingressegress.groupedByCamera, "cameraName");
          const list_cameraingress = map(data.ingressegress.groupedByCamera, "total_ingress_count")     
          setEntryWiseBarData((prevState) => ({
            ...prevState,
            options: {
              ...prevState.options,

              xaxis: { ...prevState.options.xaxis, categories: list_cameraName },
            },
            series: [{ name: "Total FootFall", data: list_cameraingress }],
          }));      
        }
        if(data.storeIngress != null)
        {
          const multiselectData = data.storeIngress.map((item) => ({
            label: item.storesName,
            value: item.storesId,
          }));
          setstoreslist(multiselectData);
          setStoresFootfallDwell(data.storeIngress)
          setIngressLive(false)
          setDwellLive(false)
        }
      }
    }
  })

  useExactInterval_Dwell(async () => {
    if ((dwellLive === true && dwell_socketcheck === false)) {
      const req = {
        headers: { authorization: authService.getCurrentUser() },
        query: {
          date: "",
          camid: "",
          floorId: props.props[0] ? props.props[0].id : null,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          zoneId: props.props[1] ? props.props[1].id : null,
          zonecameraIds: props.props[1] ? props.props[1].cameraIds : null,
          storesId: Object.keys(selectedstores).length > 0 ? selectedstores.storesId : null,
          storescameraIds: Object.keys(selectedstores).length > 0 ? selectedstores.cameraIds : null,
        },
      };
      if (dwell_socketcheck === false) {
        dwell_socketcheck = true
        socket.emit("Dwell_Time", req)
      }
    }
  });

  socket.on("Dwell_time", (data) => {
    if (dwell_socketcheck === true) {
      dwell_socketcheck = false
      if (data.dwellengagebounce != null) {
        const list_hour = Object.keys(data.dwellengagebounce.engagedbouncedhours)
        const list_engaged = Object.values(data.dwellengagebounce.engagedbouncedhours).map(obj => Object.values(obj)[0].engaged)
        const list_bounce = Object.values(data.dwellengagebounce.engagedbouncedhours).map(obj => Object.values(obj)[0].bounce)
        setEngageChartData((prev) => ({
          ...prev,
          options: {
            ...prev.options,
            xaxis: {
              // ...prev.options.xaxis,
              categories: list_hour,
              title: {
                text: "Hour",
                offsetY: -10,
              },
            },
            title: {
              text: "Engaged" + " - " + data.dwellengagebounce.engagedbounced[0].totalengaged,
              align: "center",
              margin: 10,
              style: {
                fontSize: "16px",
                fontFamily: "Helvetica",
              },
            },
          },
          series: [
            {
              name: "Engaged",
              data: list_engaged,
            },
          ],
        }));

        setBounceChartData((prev) => ({
          ...prev,
          options: {
            ...prev.options,
            xaxis: {
              // ...prev.options.xaxis,
              categories: list_hour,
              title: {
                text: "Hour",
                offsetY: -10,
              },
            },
            title: {
              text: "Bounced" + " - " + data.dwellengagebounce.engagedbounced[0].totalbounce,
              align: "center",
              margin: 10,
              style: {
                fontSize: "16px",
                fontFamily: "Helvetica",
              },
            },
          },
          series: [
            {
              name: "Bounced",
              data: list_bounce,
            },
          ],
        }));

        // setTotalLiveOccupancyCount(
        //   data.dwellengagebounce.liveoccupancy.map((item) => item.bounce).reduce((acc, num) => acc + num, 0)
        //   + data.dwellengagebounce.liveoccupancy.map((item) => item.engaged).reduce((acc, num) => acc + num, 0)
        // )

        const dwell_hour = Object.keys(data.dwellengagebounce.dwelltimehours)
        const dwell_avg = Object.values(data.dwellengagebounce.dwelltimehours).map(obj => Object.values(obj)[0].totalavg)
        setDwellBarData((prevState) => ({
          ...prevState,
          options: {
            ...prevState.options,

            xaxis: { ...prevState.options.xaxis, categories: dwell_hour },
          },
          series: [{ name: "AvgDwell", data: dwell_avg }],
        }));

        const responseData1 = Object.values(data.dwellengagebounce.engagedbouncedcameras).sort((a, b) => b.engaged - a.engaged)
        const engagedData = responseData1.map((item) => item.engaged);
        const bouncedData = responseData1.map((item) => item.bounced);
        const categories1 = responseData1.map((item) => item.cameraName);

        setEngageBounceWiseBarData((prevState) => ({
          ...prevState,
          graph: {
            ...prevState.graph,
            series: [
              {
                name: "Engaged",
                data: engagedData,
              },
              {
                name: "Bounced",
                data: bouncedData,
              },
            ],
            options: {
              ...prevState.graph.options,
              xaxis: {
                categories: categories1,
              },
            },
          },
        }));
      }
    }
  })

  useExactInterval_Crowd(async () => {
    if ((dwellLive === true && crowd_socketcheck === false)) {
      const req = {
        headers: { authorization: authService.getCurrentUser() },
        query: {
          date: "",
          camid: "",
          floorId: props.props[0] ? props.props[0].id : null,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          zoneId: props.props[1] ? props.props[1].id : null,
          zonecameraIds: props.props[1] ? props.props[1].cameraIds : null,
          storesId: Object.keys(selectedstores).length > 0 ? selectedstores.storesId : null,
          storescameraIds: Object.keys(selectedstores).length > 0 ? selectedstores.cameraIds : null,
        },
      };
      if (crowd_socketcheck === false) {
        crowd_socketcheck = true
        socket.emit("Crowd_Analysis", req)
      }
    }
  });

  socket.on("Crowd_analysis", (data) => {
    if (crowd_socketcheck === true) {
      crowd_socketcheck = false
      if (data.crowdanalysis != null) {
        setTotalLiveOccupancyCount(data.crowdanalysis.map((item) => item.count).reduce((acc, num) => acc + num, 0))
        setTotalCrowdAnalysisCount(data.crowdanalysis.map((item) => item.count).reduce((acc, num) => acc + num, 0))
        setdata(data.crowdanalysis);
      }
    }
  })
  
  function handlestoreCardClick(storesData) {
    setselectedstores(storesData)
    setIngressLive(storesData.ingress)
    setDwellLive(storesData.dwell)
    get_eventbased(storesData)
    if (storesData.ingress === true) {
      get_ingress(storesData)
    }
    if (storesData.dwell === true) {
      get_dwell(storesData) 
    }
  }

  function handleFilterChange(storesId) {
    setselectedstoresList(storeslist.filter(item => storesId.includes(item.value)))
    setselectedstoresIds(storesId)
  }

  function onclickbackto() 
  {
    setStoresLive(true)
    setIngressLive(false)
    setDwellLive(false)
    setselectedstores({})
    setselectedstoresList(storeslist.filter(item => selectedstoresIds.includes(item.value)))
  }

  function get_eventbased(stores_data) {
    axiosClient
    .get(`livereport/geteventbasedactivecameraformall?floorId=${props.props[0] ? props.props[0].id : null}&zoneId=${props.props[1] ? props.props[1].id : null}&zonecameraIds=${props.props[1] ? props.props[1].cameraIds : null}&storesId=${Object.keys(stores_data).length > 0 ? stores_data.storesId : props.props[2] ? props.props[2].id : null}&storescameraIds=${Object.keys(stores_data).length > 0 ? stores_data.cameraIds : props.props[2] ? props.props[2].cameraIds : null}`)
    .then((response) => {
      if (response.data.issuccess === true) {
        if (response.data.data.length > 0) {
          const eventsbasedcamera = response.data.data[0].eventDetail;
          seteventbasedactivecamera(eventsbasedcamera);
          if (Object.keys(stores_data).length === 0) {
            if (eventsbasedcamera.length > 0) {
              if (eventsbasedcamera.find(item => item.eventName === 'Ingress')) {
                setingresscameras(eventsbasedcamera.find(item => item.eventName === 'Ingress').cameraCount)
                setIngressLive(true)
                get_ingress({})
              }   
              else {
                setingresscameras(0)
              }         
              if (eventsbasedcamera.find(item => item.eventName === 'Dwell')) {
                setdwellcameras(eventsbasedcamera.find(item => item.eventName === 'Dwell').cameraCount)
                setDwellLive(true)
                get_dwell({})
              }
              else {
                setdwellcameras(0)
              }
              if (eventsbasedcamera.find(item => item.eventName === 'StoreIngress')) {
                setstoreingresscameras(eventsbasedcamera.find(item => item.eventName === 'StoreIngress').cameraCount)
              }
              else {
                setstoreingresscameras(0)
              }
            }
            else {
              setIngressLive(true)
              setDwellLive(true)
              get_ingress({})
              get_dwell({})
            }
          }
          const totalcount = response.data.data[0].totalCamera;
          settotalfootfallactivecamera(totalcount);
        } else {
          const totalcount = 0;
          settotalfootfallactivecamera(totalcount);
          setIngressLive(true)
          setDwellLive(true)
          get_ingress({})
          get_dwell({})
        }
      }
    })
    .catch((err) => {
    });
  }

  function get_ingress(stores_data){
    axiosClient
    .get(
      `livereport/getingressegress?date=${HandleDateForIngressEgress.SelectedDate}&camid=&floorId=${props.props[0] ? props.props[0].id : null}&zoneId=${props.props[1] ? props.props[1].id : null}&zonecameraIds=${props.props[1] ? props.props[1].cameraIds : null}&storesId=${Object.keys(stores_data).length > 0 ? stores_data.storesId : props.props[2] ? props.props[2].id : null}&storescameraIds=${Object.keys(stores_data).length > 0 ? stores_data.cameraIds : props.props[2] ? props.props[2].cameraIds : null}`
    )
    .then((response) => {
      if (response.data.issuccess === true) {
        setingressloading(false);
        settotalingress(response.data.data.total_ingress_egress);
        settotalingresspercentage(response.data.data.percentage_ingress_basedOnTime);
        setpeakHour(response.data.data.currentPeakHourRange);
        setyesterdaypeakHour(response.data.data.yesterdayPeakHourRange);
        setPasserByCount(response.data.data.passerByLists);
        const list_hour = map(response.data.data.total_records_hour, "hour");

        const list_ingress = map(
          response.data.data.total_records_hour,
          "totalingress"
        );
        // const list_egress = map(
        //   response.data.data.total_records_hour,
        //   "totalegress"
        // );
        setChartData((prev) => ({
          ...prev,
          options: {
            ...prev.options,
            xaxis: {
              // ...prev.options.xaxis,
              categories: list_hour,
                   title: {
                text: "Hour",
                offsetY: -10,
              },
            },
          },
          series: [
            {
              name: "Ingress",
              data: list_ingress,
            },
            // {
            //   name: "Egress",
            //   data: list_egress,
            // },
          ],
        }));

        const list_cameraName = map(response.data.data.groupedByCamera, "cameraName");
        const list_cameraingress = map(response.data.data.groupedByCamera, "total_ingress_count")
        setEntryWiseBarData((prevState) => ({
          ...prevState,
          options: {
            ...prevState.options,

            xaxis: { ...prevState.options.xaxis, categories: list_cameraName },
          },
          series: [{ name: "Total FootFall", data: list_cameraingress }],
        }));   
      }
    })
    .catch((err) => {
      if (err.status === 0) {
        message.error("Network error");
      } else {
        message.error(err.message);
      }
    });
  }

  function get_dwell(stores_data) {
    axiosClient
      .get(
        `livereport/getdwellengagebounced?startDate=${moment().format("YYYY-MM-DD")}&endDate=${moment().format("YYYY-MM-DD")}&floorId=${props.props[0] ? props.props[0].id : null}&zoneId=${props.props[1] ? props.props[1].id : null}&zonecameraIds=${props.props[1] ? props.props[1].cameraIds : null}&storesId=${Object.keys(stores_data).length > 0 ? stores_data.storesId : props.props[2] ? props.props[2].id : null}&storescameraIds=${Object.keys(stores_data).length > 0 ? stores_data.cameraIds : props.props[2] ? props.props[2].cameraIds : null}`
      )
      .then((response) => {
        if (response.data.issuccess === true) {
          const list_hour = Object.keys(response.data.data.engagedbouncedhours)
          const list_engaged = Object.values(response.data.data.engagedbouncedhours).map(obj => Object.values(obj)[0].engaged)
          const list_bounce = Object.values(response.data.data.engagedbouncedhours).map(obj => Object.values(obj)[0].bounce)

          setEngageChartData((prev) => ({
            ...prev,
            options: {
              ...prev.options,
              xaxis: {
                // ...prev.options.xaxis,
                categories: list_hour,
                title: {
                  text: "Hour",
                  offsetY: -10,
                },
              },
              title: {
                text: "Engaged" + " - " + response.data.data.engagedbounced[0].totalengaged,
                align: "center",
                margin: 10,
                style: {
                  fontSize: "16px",
                  fontFamily: "Helvetica",
                },
              },
            },
            series: [
              {
                name: "Engaged",
                data: list_engaged,
              },
            ],
          }));

          setBounceChartData((prev) => ({
            ...prev,
            options: {
              ...prev.options,
              xaxis: {
                // ...prev.options.xaxis,
                categories: list_hour,
                title: {
                  text: "Hour",
                  offsetY: -10,
                },
              },
              title: {
                text: "Bounced" + " - " + response.data.data.engagedbounced[0].totalbounce,
                align: "center",
                margin: 10,
                style: {
                  fontSize: "16px",
                  fontFamily: "Helvetica",
                },
              },
            },
            series: [
              {
                name: "Bounced",
                data: list_bounce,
              },
            ],
          }));

          // setTotalLiveOccupancyCount(
          //   response.data.data.liveoccupancy.map((item) => item.bounce).reduce((acc, num) => acc + num, 0)
          //   + response.data.data.liveoccupancy.map((item) => item.engaged).reduce((acc, num) => acc + num, 0)
          // )

          const dwell_hour = Object.keys(response.data.data.dwelltimehours)
          const dwell_avg = Object.values(response.data.data.dwelltimehours).map(obj => Object.values(obj)[0].totalavg)
          setDwellBarData((prevState) => ({
            ...prevState,
            options: {
              ...prevState.options,

              xaxis: { ...prevState.options.xaxis, categories: dwell_hour },
            },
            series: [{ name: "AvgDwell", data: dwell_avg }],
          }));

          const responseData1 = Object.values(response.data.data.engagedbouncedcameras).sort((a,b) => b.engaged - a.engaged)
          const engagedData = responseData1.map((item) => item.engaged);
          const bouncedData = responseData1.map((item) => item.bounced);
          const categories1 = responseData1.map((item) => item.cameraName);

          setEngageBounceWiseBarData((prevState) => ({
            ...prevState,
            graph: {
              ...prevState.graph,
              series: [
                {
                  name: "Engageg",
                  data: engagedData,
                },
                {
                  name: "Bounced",
                  data: bouncedData,
                },
              ],
              options: {
                ...prevState.graph.options,
                xaxis: {
                  categories: categories1,
                },
              },
            },
          }));

          // setEngagersweeklychart((prevState) => ({
          //   ...prevState,
          //   options: {
          //     ...prevState.options,

          //     xaxis: { ...prevState.options.xaxis, categories: categories },
          //   },
          //   series: [{ name: "Engagers", data: EngagedDate }],
          // }));
          // setBouncedweeklychart((prevState) => ({
          //   ...prevState,
          //   options: {
          //     ...prevState.options,

          //     xaxis: { ...prevState.options.xaxis, categories: categories },
          //   },
          //   series: [
          //     {
          //       ...prevState.options.series,
          //       name: "Bounced",
          //       data: BouncedData,
          //     },
          //   ],
          // })); 


          // const data = response.data.data.dwelltime.dwellData || [];
          // //const CameraList = response.data.data.dwelltime.cameraData || [];
          // //updateCameraList(CameraList);

          // if (data.length > 0) {
          //   const zoneNames = extractZoneNames1(data).sort();
          //   const { hours, series } = transformData1(data, zoneNames);
          //   // setDwellHourlyDateWise((prevState) => ({
          //   //   ...prevState,
          //   //   options: {
          //   //     ...prevState.options,
          //   //     xaxis: {
          //   //       ...prevState.options.xaxis,
          //   //       categories: hours,
          //   //     },
          //   //   },
          //   //   series: series,
          //   //   selectedCam: response.data.data.dwelltime.selectedCameraDetails.cameraId,
          //   // }));
          // } else {
          //   // setDwellHourlyDateWise((prevState) => ({
          //   //   ...prevState,
          //   //   options: {
          //   //     ...prevState.options,
          //   //     xaxis: {
          //   //       ...prevState.options.xaxis,
          //   //       categories: [],
          //   //     },
          //   //   },
          //   //   series: [],
          //   // }));
          // }
        }
      })
      .catch((error) => {
      });

    axiosClient
      .get(`crowdAnalysis/getCrowdAnalysisDetails?floorId=${props.props[0] ? props.props[0].id : null}&zoneId=${props.props[1] ? props.props[1].id : null}&zonecameraIds=${props.props[1] ? props.props[1].cameraIds : null}&storesId=${Object.keys(stores_data).length > 0 ? stores_data.storesId : props.props[2] ? props.props[2].id : null}&storescameraIds=${Object.keys(stores_data).length > 0 ? stores_data.cameraIds : props.props[2] ? props.props[2].cameraIds : null}`)
      .then((response) => {
        if (response.data.issuccess === true) {
          setTotalLiveOccupancyCount(response.data.data.map((item) => item.count).reduce((acc, num) => acc + num, 0))
          setTotalCrowdAnalysisCount(response.data.data.map((item) => item.count).reduce((acc, num) => acc + num, 0))
          setdata(response.data.data);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.message);
        }
      });
  }

  function get_stores(){
    axiosClient
    .get(
      `livereport/getstoresingressdwell?startDate=${moment().format("YYYY-MM-DD")}&endDate=${moment().format("YYYY-MM-DD")}&storeId=${props.props[2] ? props.props[2][0].storeId : null}`
    )
    .then((response) => {
      if (response.data.issuccess === true) {
        const multiselectData = response.data.data.map((item) => ({
          label: item.storesName,
          value: item.storesId,
        }));
        setstoreslist(multiselectData);
        setStoresFootfallDwell(response.data.data)
        setIngressLive(false)
        setDwellLive(false)
      }
    })
    .catch((err) => {
      if (err.status === 0) {
        message.error("Network error");
      } else {
        message.error(err.message);
      }
    });
  }

  useEffect(() => {
    try {  
      if(props.props[2] === null)
      {
        get_eventbased({})
      }     
      if (props.props[2]) {        
        setStoresLive(true)
        get_stores()
      }
      else {    
        setselectedstores({}) 
        setStoresLive(false)
        if(props.props[1])
        {
          setIngressLive(props.props[1].ingress)
          setDwellLive(props.props[1].dwell)
           
          if (props.props[1].ingress === true) {
            get_ingress({})
          }
          if (props.props[1].dwell === true) {
            get_dwell({})
          }                   
        }      
        else if(props.props[0])
        {
          setIngressLive(props.props[0].ingress)
          setDwellLive(props.props[0].dwell) 
          
          if (props.props[0].ingress === true) {
            get_ingress({})
          }
          if (props.props[0].dwell === true) {
            get_dwell({})            
          }   
        }           
      }     
        // try {
        //   FetchDataForCrowdAnalysis();
        // } catch (err) {
        // }
    }
    catch (ex)
    {
    }   
  }, [props.props[0], props.props[1], props.props[2]]);

  // useEffect(() => {
  //   // PasserByNew();
  //   // getPasserByCount()
  //   // getOverallPasserByCount()

    

  //   // const today = new Date();
  //   // const startDate = today.toISOString().split("T")[0];
  //   // const endDate = today.toISOString().split("T")[0];

  //   // axiosClient
  //   //   .get("/livereport/getcameralistforingressegresslive", {
  //   //     params: {
  //   //       startDate,
  //   //       endDate,
  //   //     },
  //   //   })
  //   //   .then((response) => {
  //   //     setMenuOptions(response.data.data);
  //   //   })
  //   //   .catch((error) => {
  //   //   });
  // }, [props.props[0], props.props[1], props.props[2]]);

  // useEffect(() => {
  //   axiosClient
  //     .get(
  //       `/dwelltime/getDwellTimeHourData?date=${dayjs(
  //         EngageBounceHourController.selectedDate
  //       ).format("YYYY-MM-DD")}&camId=${EngageBounceHourController.selectedcam}`
  //     )

  //     .then((response) => {
  //       if (response.data.issuccess === true) {
  //         const data = response.data.data.dwellData
  //           ? response.data.data.dwellData
  //           : [];

  //         const selectedcamDetails = response.data.data.selectedCameraDetails;
  //         const CameraList = response.data.data.cameraData;
  //         if (selectedcamDetails) {
  //           setEngageBounceHourController((prev) => ({
  //             ...prev,
  //             selectedcam: selectedcamDetails.cameraId,
  //           }));
  //         }
  //         if (CameraList !== null && CameraList !== undefined) {
  //           const newCamList = CameraList.map((item) => ({
  //             value: item.cameraId,
  //             label: item.cameraName,
  //           }));

  //           setEngageBounceHourController((prev) => ({
  //             ...prev,
  //             camlist: [...newCamList],
  //           }));
  //         }

  //         if (data.length > 0 || data !== null || data !== undefined) {
  //           const zoneNames = extractZoneNames(data).sort();
  //           if (zoneNames.length > 0) {
  //             const { hours, seriesEngage, seriesBounce } = transformDataEngageAndBounce(data, zoneNames);

  //             setEngagedHourlyChart((prevState) => ({
  //               ...prevState,
  //               options: {
  //                 ...prevState.options,
  //                 xaxis: {
  //                   ...prevState.options.xaxis,
  //                   categories: hours,
  //                 },
  //               },
  //               series: seriesEngage,
  //             }));

  //             setBouncedHourlyChart((prevState) => ({
  //               ...prevState,
  //               options: {
  //                 ...prevState.options,
  //                 xaxis: {
  //                   ...prevState.options.xaxis,
  //                   categories: hours,
  //                 },
  //               },
  //               series: seriesBounce,
  //             }));

  //             setEngageBounceHourController((prev) => ({
  //               ...prev,
  //               DataOfDate: EngageBounceHourController.selectedDate,
  //             }));
  //           }
  //         }
  //       } else {
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // }, [
  //   EngageBounceHourController.selectedcam,
  //   EngageBounceHourController.selectedDate,
  // ]);

  // useEffect(() => {
  //   axiosClient
  //     .get(
  //       `/dwelltime/getDwellTimeHourData?date=${DwellHourlyController.selectedDate}&camId=${DwellHourlyController.selectedcam}`
  //     )

  //     .then((response) => {
  //       if (response.data.issuccess === true) {
  //         const data = response.data.data.dwellData
  //           ? response.data.data.dwellData
  //           : [];

  //         // const selectedcamDetails = response.data.data.selectedCameraDetails;
  //         const CameraList = response.data.data.cameraData;
  //         // if (selectedcamDetails) {
  //         //   setDwellHourlyController((prev) => ({
  //         //     ...prev,
  //         //     selectedcam: selectedcamDetails.cameraId,
  //         //     selectedcameraname: selectedcamDetails.cameraName,
  //         //   }));
  //         // }
  //         if (CameraList !== null && CameraList !== undefined) {
  //           const newCamList = CameraList.map((item) => ({
  //             value: item.cameraId,
  //             label: item.cameraName,
  //           }));

  //           setDwellHourlyController((prev) => ({
  //             ...prev,
  //             camlist: [...newCamList],
  //           }));
  //           // CameraList.map((item) => {
  //           //   let cam = {
  //           //     value: item.cameraId,
  //           //     label: item.cameraName,
  //           //   };

  //           //   setDwellHourlyController((prev) => ({
  //           //     ...prev,
  //           //     camlist: [...prev.camlist, cam],
  //           //   }));
  //           // });
  //         }

  //         if (data.length > 0 || data !== null || data !== undefined) {
  //           const zoneNames = extractZoneNames(data).sort();
  //           if (zoneNames.length > 0) {
  //             const { hours, series, seriesEngage, seriesBounce } = transformData(data, zoneNames);
  //             setDwellHourly((prevState) => ({
  //               ...prevState,
  //               options: {
  //                 ...prevState.options,
  //                 xaxis: {
  //                   ...prevState.options.xaxis,
  //                   categories: hours,
  //                 },
  //               },
  //               series: series,
  //             }));

  //             setDwellHourlyController((prev) => ({
  //               ...prev,
  //               DataOfDate: DwellHourlyController.selectedDate,
  //             }));
  //           }
  //         }
  //       } else {
  //       }
  //     })
  //     .catch((err) => {
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // }, [DwellHourlyController.selectedcam, DwellHourlyController.selectedDate]);

  // useEffect(() => {
  //   setFootfallDirectionHourlyController((prev) => ({
  //     ...prev,
  //     loading: true,
  //   }));
  //   axiosClient
  //     .get(
  //       `/livereport/getfootfalldirectionimage?date=${FootfallDirectionHourlyController.selectedDate}&camId=${FootfallDirectionHourlyController.selectedcam}&hour=${FootfallDirectionHourlyController.Hour}`
  //     )
  //     //${FootfallDirectionHourlyController.Hour}

  //     .then((response) => {
  //       if (response.data.issuccess === true) {

  //         const selectedcamDetails = response.data.data;
  //         const CameraList = response.data.data.cameraData;
  //         if (
  //           selectedcamDetails.selectedCameraData !== null &&
  //           selectedcamDetails.selectedCameraData !== undefined &&
  //           selectedcamDetails.selectedCameraData !== ""
  //         ) {
  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             selectedcam: selectedcamDetails.selectedCameraData.cameraId,

  //             selectedcamName: selectedcamDetails.selectedCameraData.cameraName,
  //           }));
  //         }

  //         if (
  //           selectedcamDetails.directionData !== null &&
  //           selectedcamDetails.directionData !== undefined &&
  //           selectedcamDetails.directionData !== ""
  //         ) {
  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             DirectionData: selectedcamDetails.directionData,
  //           }));
  //         }
  //         if (
  //           selectedcamDetails.directionImage !== null &&
  //           selectedcamDetails.directionImage !== undefined
  //         ) {
  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             DirectionImage: selectedcamDetails.directionImage,
  //           }));
  //         } else {
  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             DirectionImage: "",
  //           }));
  //         }

  //         if (
  //           selectedcamDetails.hour !== null &&
  //           selectedcamDetails.hour !== undefined &&
  //           selectedcamDetails.hour !== ""
  //         ) {
  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             Hour: selectedcamDetails.hour,
  //           }));
  //         }
  //         if (CameraList !== null && CameraList !== undefined) {
  //           const newCamList = CameraList.map((item) => ({
  //             value: item.cameraid,
  //             label: item.cameraname,
  //           }));

  //           setFootfallDirectionHourlyController((prev) => ({
  //             ...prev,
  //             camlist: [...newCamList],
  //           }));
  //         }
  //       } else {
  //       }
  //       setFootfallDirectionHourlyController((prev) => ({
  //         ...prev,
  //         loading: false,
  //       }));
  //     })
  //     .catch((err) => {
  //       setFootfallDirectionHourlyController((prev) => ({
  //         ...prev,
  //         loading: false,
  //       }));
  //       if (err.status === 0) {
  //         message.error("Server error");
  //       } else {
  //         message.error(err.msg);
  //       }
  //     });
  // }, [
  //   FootfallDirectionHourlyController.selectedcam,
  //   FootfallDirectionHourlyController.selectedDate,
  //   FootfallDirectionHourlyController.Hour,
  // ]);

  const EngageAndBounce = () => {
    return (
      <Col
        xs={{ span: 24 / 1, offset: 0 }}
        sm={{ span: 24 / 1, offset: 0 }}
        md={{ span: 24 / 1, offset: 0 }}
        lg={{ span: 24 / 1, offset: 0 }}
        xl={{ span: 24 / 1, offset: 0 }}
      >
        <Card
          style={{
            userSelect: "none",
            boxShadow: "none",
            height: "auto",
          }}
          title={
            <>
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                    Engaged and Bounced per hour 
                  </Title>
                </Col>
              </Row>
            </>
          }
        >
          <Row justify={"space-between"} align={"middle"}>
            <Col
              xs={{ span: 23 / 1, offset: 0 }}
              sm={{ span: 24 / 1, offset: 0 }}
              md={{ span: 12 / 1, offset: 0 }}
              lg={{ span: 12 / 1, offset: 0 }}
              xl={{ span: 12 / 1, offset: 0 }}
            >
              {EngagechartData.series && EngagechartData.series.length > 0 ? (
                <div className="app">
                  <div className="row">
                    <div className="mixed-chart">
                      <ReactApexChart
                        options={EngagechartData.options}
                        series={EngagechartData.series}
                        type="area"
                        height="170%"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <Text style={{ fontSize: "16px", color: "gray" }}>
                    No Data Available
                  </Text>
                </div>
              )}
            </Col>

            <Col
              xs={{ span: 24 / 1, offset: 0 }}
              sm={{ span: 24 / 1, offset: 0 }}
              md={{ span: 12 / 1, offset: 0 }}
              lg={{ span: 12 / 1, offset: 0 }}
              xl={{ span: 12 / 1, offset: 0 }}
            >
              {BouncechartData.series && BouncechartData.series.length > 0 ? (
                <div className="app">
                  <div className="row">
                    <div className="mixed-chart">
                      <ReactApexChart
                        options={BouncechartData.options}
                        series={BouncechartData.series}
                        type="area"
                        height="170%"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <Text style={{ fontSize: "16px", color: "gray" }}>
                    No Data Available
                  </Text>
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </Col> 
    );
  };

  const EngageAndBounceCamera = () => {
    return (
      <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card
            loading={ingressloading}
            style={{
              cursor: "pointer",
              userSelect: "none",
              boxShadow: "none",
              height: "auto",
            }}
            title={
              <Row justify={"space-between"} align={"middle"}>
                <Col>
                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                    Camera Wise Engage & Bounce
                  </Title>
                </Col>
              </Row>
            }
          >
            {EngageBounceWiseBarData.graph.series && EngageBounceWiseBarData.graph.series.length > 0 ? (
              <div className="app">
                <div className="row">
                  <div style={{ width: "100%", overflowX: "auto" }}>
                    <div style={{ width: `${EngageBounceWiseBarData.graph.series[0].data.length > 15 ? ((EngageBounceWiseBarData.graph.series[0].data.length - 15) * 210) + (35 * 60) : 35 * 60}px`, minWidth: "600px" }}>
                      <div className="mixed-chart">
                        <ReactApexChart
                          type="bar"
                          options={EngageBounceWiseBarData.graph.options}
                          series={EngageBounceWiseBarData.graph.series}
                          height="170%"
                          width={EngageBounceWiseBarData.graph.series[0].data.length > 15 ? ((EngageBounceWiseBarData.graph.series[0].data.length - 15) * 210) + (35 * 60) : 35 * 60}
                        />
                      </div>
                    </div>
                </div>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Text style={{ fontSize: "16px", color: "gray" }}>
                  No Data Available
                </Text>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    );
  };

  return (    
    <div style={{ backgroundColor: "#fffff", marginBottom: "7rem" }}>
      {storesLive ? ingressLive === false && dwellLive === false && storesFootfallDwell.length > 0 ? ( 
      <Row
        gutter={[16, 16]}
        style={{
          margin: "10px",
          padding: "10px 0",
          backgroundColor: "#fff",
        }}
      >
        <Col span={12} style={{ textAlign: "left" }}>
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            mode="multiple"
            placeholder="Filter by store"
            style={{ width: 300 }}
            onChange={(item) => {
              handleFilterChange(item);
            }}
            value={selectedstoresList}
            allowClear
          >
            {storeslist.map((cam) => (
              <Option key={cam.value} value={cam.value}>
                {cam.label}
              </Option>
            ))}
          </Select>
        </Col>             
        </Row>) :
        ingressLive === false && dwellLive === false && storesFootfallDwell.length === 0 ? (
          <></>
        ) :
          <Row
            gutter={[16, 16]}
            style={{
              margin: "10px",
              padding: "10px 0",
              backgroundColor: "#fff",
            }}
          >
            <Col span={12} style={{ textAlign: "left" }}>
              <Button
                xs={24}
                md={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginRight: "50px",
                }}
                onClick={onclickbackto}
              >
                Stores Dashboard
              </Button>
            </Col>
            {Object.keys(selectedstores).length > 0 ?
              <Col span={12} style={{ textAlign: "left" }}>
                <Title level={5} type="primary" style={{ fontFamily: "Helvetica", fontWeight: "bold", fontSize: "18px" }}>
                  {selectedstores.storesName}
                </Title>
              </Col> : <></>}
          </Row> :
        <></>
      }
     
      <Row
        className="Base-row"
        gutter={[30, 20]}
        style={{
          margin: "10px",
          backgroundColor: "white",
          marginBottom: "30px",
        }}
      >
        {RenderCompController.IngressEgress && (
          (storesLive ?
            ingressLive && dwellLive ?
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row gutter={[20, 20]}>
                  <Col xs={24} sm={24} md={24} lg={15} xl={16}>
                    <Row gutter={[20, 20]}>
                      <Col xs={24} sm={24} md={24} lg={12} xl={9}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "auto",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Footfall
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: "6rem",
                            }}
                          >
                            <Col>
                              <Title
                                level={1}
                                style={{
                                  fontWeight: "normal",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                }}
                              >
                                {totalingress !== null && totalingress !== undefined
                                  ? totalingress
                                  : 0}
                              </Title>
                              <Text style={{ backgroundColor: "#abd1b5" }}>
                                {totalingrespercentage !== null && totalingrespercentage !== undefined
                                  ? totalingrespercentage > 100
                                    ? "100"
                                    : totalingrespercentage
                                  : 0}
                                %
                              </Text>
                              <Text> Vs.PreviousDay</Text>
                            </Col>
                            <Col>
                              <GiFootsteps size={70} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12} xl={15}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "auto",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Peak Hours
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: window.innerHeight > 850 ? "6rem" : "auto",
                            }}
                          >
                            <Col>
                              <Text
                                style={{
                                  fontWeight: "bold",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                  fontSize: "29px",
                                }}
                              >
                                {peakHour !== null && peakHour !== undefined && peakHour !== "Invalid date - Invalid date"
                                  ? peakHour
                                  : "- -"}
                              </Text>
                              <Text>
                                Yesterday's Peak Hours{" "}
                                {yesterdaypeakHour !== null && yesterdaypeakHour !== undefined &&
                                  yesterdaypeakHour !== "Invalid date - Invalid date"
                                  ? yesterdaypeakHour
                                  : "- -"}
                              </Text>
                            </Col>
                            <Col>
                              <ImHourGlass size={60} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>

                    </Row>
                    <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                      <Col xs={24} sm={24} md={24} lg={7} xl={9}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "190px",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Live Occupancy
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: "3rem",
                            }}
                          >
                            <Col>
                              <Title
                                level={1}
                                style={{
                                  fontWeight: "normal",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                }}
                              >
                                {totalLiveOccupancyCount}
                              </Title>
                            </Col>
                            <Col>
                              <GiTeamUpgrade size={60} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={17} xl={15}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "190px",
                          }}
                          title={
                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Title
                                type="secondary"
                                level={5}
                                style={{ fontFamily: "Helvetica" }}
                              >
                                Total Onboard Camera :
                                <span style={{ marginLeft: "7px" }}>
                                  {totalfootfallactivecamera}
                                </span>
                              </Title>
                              <div>
                                <GiCctvCamera size={40} />
                              </div>
                            </Row>
                          }
                        >
                          <Row gutter={[16, 16]} justify="center">
                            {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                              eventbasedactivecamera.map((item, index) => (
                                <Col key={index} xs={24} sm={12} md={8} style={{ height: "7rem" }}>
                                  <Card
                                    style={{
                                      textAlign: "center",
                                      borderRadius: "8px",
                                      height: "100px",
                                    }}
                                  >
                                    <Title
                                      level={5}
                                      style={{
                                        fontFamily: "Helvetica",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    >
                                      {item.eventName}
                                    </Title>
                                    <Text
                                      type="secondary"
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "10px",
                                        display: "block",
                                      }}
                                    >
                                      Active Cameras: {item.cameraCount}
                                    </Text>
                                  </Card>
                                </Col>
                              ))}
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={9} xl={8}>
                    <Row gutter={[20, 20]} >
                      <Col xs={24}>
                        <Card
                          style={{
                            overflowY: "scroll",
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "440px"
                          }}
                          styles={{
                            body: {
                              // minHeight: "150px",
                              maxHeight: "860px",
                              overflowY: "scroll",
                            },
                          }}
                          title={
                            <Row
                              justify={"space-between"}
                              align={"middle"}
                            >
                              <Col>
                                <Title type="secondary" level={5}>
                                  {"Crowd Analysis - " + totalCrowdAnalysisCount}
                                </Title>
                              </Col>
                              <Col>
                                <LiveTag />
                              </Col>
                            </Row>
                          }
                        >
                          <List
                            itemLayout="horizontal"
                            dataSource={data}
                            renderItem={(item, index) => (
                              <List.Item>
                                <List.Item.Meta
                                  avatar={
                                    <Avatar
                                      icon={
                                        <FaCameraRetro
                                          style={{ color: "blue" }}
                                        />
                                      }
                                    />
                                  }
                                  title={
                                    <Row>
                                      <Col span={19}>
                                        <Text
                                          strong
                                          style={{
                                            fontSize: "17px",
                                            marginRight: "72px",
                                          }}
                                        >
                                          {item.cameraName}
                                        </Text>
                                      </Col>
                                      <Col span={3}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent:
                                              "space-between",
                                          }}
                                        >
                                          {/* {item.trent >= 0 ? (
                                            <Tag color="blue">
                                              <ArrowUpOutlined />{" "}
                                              {Math.abs(item.trent)}%
                                            </Tag>
                                          ) : (
                                            <Tag color="red">
                                              <ArrowDownOutlined />{" "}
                                              {Math.abs(item.trent)}%
                                            </Tag>
                                          )} */}
                                        </div>
                                      </Col>
                                    </Row>
                                  }
                                  description={
                                    <div>
                                      {item.count} people Captured
                                    </div>
                                  }
                                />
                              </List.Item>
                            )}
                          />
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {storeingresscameras > 1 ?
                  <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Card
                        loading={ingressloading}
                        style={{
                          cursor: "pointer",
                          userSelect: "none",
                          boxShadow: "none",
                          height: "auto",
                        }}
                        title={
                          <Row justify={"space-between"} align={"middle"}>
                            <Col>
                              <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                Entry Wise FootFall
                              </Title>
                            </Col>
                          </Row>
                        }
                      >
                        {EntryWiseBarData.series && EntryWiseBarData.series.length > 0 ? (
                          <div className="app">
                            <div className="row">
                              <div style={{ width: "100%", overflowX: "auto" }}>
                                <div style={{ width: `${EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}px`, minWidth: "600px" }}>
                                  <div className="mixed-chart">
                                    <ReactApexChart
                                      type="bar"
                                      options={EntryWiseBarData.options}
                                      series={EntryWiseBarData.series}
                                      height="170%"
                                      width={EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <Text style={{ fontSize: "16px", color: "gray" }}>
                              No Data Available
                            </Text>
                          </div>
                        )}
                      </Card>
                    </Col>
                  </Row> : <></>
                }

                <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Card
                      loading={ingressloading}
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        boxShadow: "none",
                        height: "20rem",
                      }}
                      title={
                        <Row justify={"space-between"} align={"middle"}>
                          <Col>
                            <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                              Ingress Counts per Hour
                            </Title>
                          </Col>
                        </Row>
                      }
                    >
                      {chartData.series && chartData.series.length > 0 ? (
                        <div className="app">
                          <div className="row">
                            <div className="mixed-chart">
                              <ReactApexChart
                                options={chartData.options}
                                series={chartData.series}
                                type="area"
                                height="150%"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: "16px", color: "gray" }}>
                            No Data Available
                          </Text>
                        </div>
                      )}
                    </Card>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <Card
                  style={{
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "none",
                    height: "370px",
                  }}
                  title={
                    <Row justify={"space-between"} align={"middle"}>
                      <Col>
                        <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                          Dwell Time
                        </Title>
                      </Col>
                    </Row>
                  }
                >
                   <Skeleton loading={graphLoading}>
                  <ReactApexChart
                    options={DwellHourlyDateWise.options}
                    series={DwellHourlyDateWise.series}
                    type="bar"
                    height="auto"
                  />
                </Skeleton>
                </Card>
              </Col>
            </Row>
          </Col> */}
                </Row>

                {dwellcameras > 1 ? <EngageAndBounceCamera /> : <></>}
                
                <Row gutter={[20, 20]} style={{ marginTop: "1rem", justify: "space-between", align: "middle" }} >
                  <EngageAndBounce />
                </Row>

                <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Card
                      loading={ingressloading}
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        boxShadow: "none",
                        height: "auto",
                      }}
                      title={
                        <Row justify={"space-between"} align={"middle"}>
                          <Col>
                            <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                              Avg Dwell Time Per Hour
                            </Title>
                          </Col>
                        </Row>
                      }
                    >
                      {DwellBarData.series && DwellBarData.series.length > 0 ? (
                        <div className="app">
                          <div className="row">
                            <div className="mixed-chart">
                              <ReactApexChart
                                type="bar"
                                options={DwellBarData.options}
                                series={DwellBarData.series}
                                height="150%"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: "16px", color: "gray" }}>
                            No Data Available
                          </Text>
                        </div>
                      )}
                    </Card>
                  </Col>
                </Row>
              </Col>
              :
              ingressLive ?
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Row gutter={[20, 20]}>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "auto",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                    Footfall
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            <Col
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2rem",
                                height: "6rem",
                              }}
                            >
                              <Col>
                                <Title
                                  level={1}
                                  style={{
                                    fontWeight: "normal",
                                    margin: 0,
                                    padding: "5px",
                                    fontFamily: "Helvetica",
                                  }}
                                >
                                  {totalingress !== null && totalingress !== undefined
                                    ? totalingress
                                    : 0}
                                </Title>
                                <Text style={{ backgroundColor: "#abd1b5" }}>
                                  {totalingrespercentage !== null && totalingrespercentage !== undefined
                                    ? totalingrespercentage > 100
                                      ? "100"
                                      : totalingrespercentage
                                    : 0}
                                  %
                                </Text>
                                <Text> Vs.PreviousDay</Text>
                              </Col>
                              <Col>
                                <GiFootsteps size={70} />
                              </Col>
                            </Col>
                          </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "auto",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                    Peak Hours
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            <Col
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2rem",
                                height: window.innerHeight > 850 ? "6rem" : "auto",
                              }}
                            >
                              <Col>
                                <Text
                                  style={{
                                    fontWeight: "bold",
                                    margin: 0,
                                    padding: "5px",
                                    fontFamily: "Helvetica",
                                    fontSize: "29px",
                                  }}
                                >
                                  {peakHour !== null && peakHour !== undefined && peakHour !== "Invalid date - Invalid date"
                                    ? peakHour
                                    : "- -"}
                                </Text>
                                <Text>
                                  Yesterday's Peak Hours{" "}
                                  {yesterdaypeakHour !== null && yesterdaypeakHour !== undefined &&
                                    yesterdaypeakHour !== "Invalid date - Invalid date"
                                    ? yesterdaypeakHour
                                    : "- -"}
                                </Text>
                              </Col>
                              <Col>
                                <ImHourGlass size={60} />
                              </Col>
                            </Col>
                          </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "230px",
                            }}
                            title={
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Title
                                  type="secondary"
                                  level={5}
                                  style={{ fontFamily: "Helvetica" }}
                                >
                                  Total Onboard Camera :
                                  <span style={{ marginLeft: "7px" }}>
                                    {totalfootfallactivecamera}
                                  </span>
                                </Title>
                                <div>
                                  <GiCctvCamera size={40} />
                                </div>
                              </Row>
                            }
                          >
                            <Row gutter={[16, 16]} justify="center">
                              {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                                eventbasedactivecamera.map((item, index) => (
                                  <Col key={index} xs={24} sm={12} md={12} lg={12} xl={12}>
                                    <Card
                                      style={{
                                        textAlign: "center",
                                        borderRadius: "8px",
                                        height: "100px",
                                        margin: "0 auto",
                                      }}
                                    >
                                      <Title
                                        level={5}
                                        style={{
                                          fontFamily: "Helvetica",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      >
                                        {item.eventName}
                                      </Title>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "10px",
                                          display: "block",
                                        }}
                                      >
                                        Active Cameras: {item.cameraCount}
                                      </Text>
                                    </Card>
                                  </Col>
                                ))}
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {storeingresscameras> 1 ?
                    <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card
                          loading={ingressloading}
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "22rem",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                  Entry Wise FootFall
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          {EntryWiseBarData.series && EntryWiseBarData.series.length > 0 ? (
                           <div className="app">
                            <div className="row">
                              <div style={{ width: "100%", overflowX: "auto" }}>
                                <div style={{ width: `${EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}px`, minWidth: "600px" }}>
                                  <div className="mixed-chart">
                                    <ReactApexChart
                                      type="bar"
                                      options={EntryWiseBarData.options}
                                      series={EntryWiseBarData.series}
                                      height="170%"
                                      width={EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          ) : (
                            <div style={{ textAlign: "center", padding: "20px" }}>
                              <Text style={{ fontSize: "16px", color: "gray" }}>
                                No Data Available
                              </Text>
                            </div>
                          )}
                        </Card>
                      </Col>
                    </Row> : <></>
                  }
               
                  <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Card
                        loading={ingressloading}
                        style={{
                          cursor: "pointer",
                          userSelect: "none",
                          boxShadow: "none",
                          height: "20rem",
                        }}
                        title={
                          <Row justify={"space-between"} align={"middle"}>
                            <Col>
                              <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                Ingress Counts per Hour
                              </Title>
                            </Col>
                          </Row>
                        }
                      >
                        {chartData.series && chartData.series.length > 0 ? (
                          <div className="app">
                            <div className="row">
                              <div className="mixed-chart">
                                <ReactApexChart
                                  options={chartData.options}
                                  series={chartData.series}
                                  type="area"
                                  height="150%"
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <Text style={{ fontSize: "16px", color: "gray" }}>
                              No Data Available
                            </Text>
                          </div>
                        )}
                      </Card>
                    </Col>
                  </Row>
                </Col>
                :
                dwellLive ?
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Row gutter={[20, 20]}>
                      <Col xs={24} sm={24} md={24} lg={15} xl={16}>
                        <Row gutter={[20, 20]}>
                          <Col xs={24} sm={24} md={24} lg={7} xl={9}>
                            <Card
                              className="ingress-hover"
                              style={{
                                cursor: "pointer",
                                userSelect: "none",
                                boxShadow: "none",
                                height: "190px",
                              }}
                              title={
                                <Row justify={"space-between"} align={"middle"}>
                                  <Col>
                                    <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                      Live Occupancy
                                    </Title>
                                  </Col>
                                </Row>
                              }
                            >
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginTop: "2rem",
                                  height: "3rem",
                                }}
                              >
                                <Col>
                                  <Title
                                    level={1}
                                    style={{
                                      fontWeight: "normal",
                                      margin: 0,
                                      padding: "5px",
                                      fontFamily: "Helvetica",
                                    }}
                                  >
                                    {totalLiveOccupancyCount}
                                  </Title>
                                </Col>
                                <Col>
                                  <GiTeamUpgrade size={60} />
                                </Col>
                              </Col>
                            </Card>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={17} xl={15}>
                            <Card
                              className="ingress-hover"
                              style={{
                                cursor: "pointer",
                                userSelect: "none",
                                boxShadow: "none",
                                height: "190px",
                              }}
                              title={
                                <Row
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Title
                                    type="secondary"
                                    level={5}
                                    style={{ fontFamily: "Helvetica" }}
                                  >
                                    Total Onboard Camera :
                                    <span style={{ marginLeft: "7px" }}>
                                      {totalfootfallactivecamera}
                                    </span>
                                  </Title>
                                  <div>
                                    <GiCctvCamera size={40} />
                                  </div>
                                </Row>
                              }
                            >
                              <Row gutter={[16, 16]} justify="center">
                                {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                                  eventbasedactivecamera.map((item, index) => (
                                    <Col key={index} xs={24} sm={12} md={8} style={{ height: "7rem" }}>
                                      <Card
                                        style={{
                                          textAlign: "center",
                                          borderRadius: "8px",
                                          height: "100px",
                                        }}
                                      >
                                        <Title
                                          level={5}
                                          style={{
                                            fontFamily: "Helvetica",
                                            fontWeight: "bold",
                                            margin: 0,
                                          }}
                                        >
                                          {item.eventName}
                                        </Title>
                                        <Text
                                          type="secondary"
                                          style={{
                                            fontSize: "14px",
                                            marginTop: "10px",
                                            display: "block",
                                          }}
                                        >
                                          Active Cameras: {item.cameraCount}
                                        </Text>
                                      </Card>
                                    </Col>
                                  ))}
                              </Row>
                            </Card>
                          </Col>
                        </Row>

                        <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>

                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Card
                              loading={ingressloading}
                              style={{
                                cursor: "pointer",
                                userSelect: "none",
                                boxShadow: "none",
                                height: "20rem",
                              }}
                              title={
                                <Row justify={"space-between"} align={"middle"}>
                                  <Col>
                                    <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                      Avg Dwell Time Per Hour
                                    </Title>
                                  </Col>
                                </Row>
                              }
                            >
                              {DwellBarData.series && DwellBarData.series.length > 0 ? (
                                <div className="app">
                                  <div className="row">
                                    <div className="mixed-chart">
                                      <ReactApexChart
                                       type="bar"
                                       options={DwellBarData.options}
                                       series={DwellBarData.series}
                                       height="150%"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div style={{ textAlign: "center", padding: "20px" }}>
                                  <Text style={{ fontSize: "16px", color: "gray" }}>
                                    No Data Available
                                  </Text>
                                </div>
                              )}                             
                            </Card>
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={24} sm={24} md={24} lg={9} xl={8}>
                        <Row gutter={[20, 20]} >
                          <Col xs={24}>
                            <Card
                              style={{
                                overflowY: "scroll",
                                cursor: "pointer",
                                userSelect: "none",
                                boxShadow: "none",
                                height: "546px"
                              }}
                              styles={{
                                body: {
                                  // minHeight: "150px",
                                  maxHeight: "860px",
                                  overflowY: "scroll",
                                },
                              }}
                              title={
                                <Row
                                  justify={"space-between"}
                                  align={"middle"}
                                >
                                  <Col>
                                    <Title type="secondary" level={5}>
                                      {"Crowd Analysis - " + totalCrowdAnalysisCount}
                                    </Title>
                                  </Col>
                                  <Col>
                                    <LiveTag />
                                  </Col>
                                </Row>
                              }
                            >
                              <List
                                itemLayout="horizontal"
                                dataSource={data}
                                renderItem={(item, index) => (
                                  <List.Item>
                                    <List.Item.Meta
                                      avatar={
                                        <Avatar
                                          icon={
                                            <FaCameraRetro
                                              style={{ color: "blue" }}
                                            />
                                          }
                                        />
                                      }
                                      title={
                                        <Row>
                                          <Col span={19}>
                                            <Text
                                              strong
                                              style={{
                                                fontSize: "17px",
                                                marginRight: "72px",
                                              }}
                                            >
                                              {item.cameraName}
                                            </Text>
                                          </Col>
                                          <Col span={3}>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent:
                                                  "space-between",
                                              }}
                                            >
                                              {/* {item.trent >= 0 ? (
                                                <Tag color="blue">
                                                  <ArrowUpOutlined />{" "}
                                                  {Math.abs(item.trent)}%
                                                </Tag>
                                              ) : (
                                                <Tag color="red">
                                                  <ArrowDownOutlined />{" "}
                                                  {Math.abs(item.trent)}%
                                                </Tag>
                                              )} */}
                                            </div>
                                          </Col>
                                        </Row>
                                      }
                                      description={
                                        <div>
                                          {item.count} people Captured
                                        </div>
                                      }
                                    />
                                  </List.Item>
                                )}
                              />
                            </Card>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                   {dwellcameras > 1 ? <EngageAndBounceCamera /> : <></>}

                    <Row gutter={[20, 20]} style={{ marginTop: "1rem", justify: "space-between", align: "middle" }} >
                      <EngageAndBounce />
                    </Row>
                  </Col>
                  :
                  <Row gutter={[16, 16]} justify="start" style={{ margin: 0, width: '100%' }}>
                    {
                      storesFootfallDwell.length > 0 ? (
                        (selectedstoresIds.length === 0
                          ? storesFootfallDwell
                          : storesFootfallDwell.filter(item => selectedstoresIds.includes(item.storesId))
                        ).map((item) => (
                          <Col
                            xs={12}
                            sm={12}
                            md={8}
                            lg={8}
                            xl={6}
                            xxl={4}
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <Card
                              title={
                                <div style={{ textAlign: "center" }}>
                                  <strong>{item.storesName}</strong>
                                </div>
                              }
                              headStyle={{ marginBottom: "2px", paddingBottom: "2px" }}
                              bodyStyle={{ paddingTop: "4px", paddingBottom: "4px" }}
                              onClick={() => handlestoreCardClick(item)}
                              style={{
                                width: "100%",
                                maxWidth: "560px",
                                minHeight: "180px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                                transition: "all 0.3s",
                                border: "1px solid rgb(53, 54, 53)",

                              }}
                              hoverable
                              bordered
                              onMouseEnter={(e) => {
                                e.currentTarget.style.border = "2px solid #1890ff"; // Ant Design primary blue
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 144, 255, 0.2)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.border = "1px solid rgb(82, 83, 82)";
                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(82, 79, 79, 0.1)";
                              }}

                            >
                              {item.ingress && (
                                <p style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", margin: "4px 0" }}>
                                  FootFall = {" "}
                                  <strong style={{ color: "green", fontSize: "17px" }}>
                                    {item.total_ingress_count}
                                  </strong>
                                </p>
                              )}
                              {item.dwell && (
                                <>
                                  <p style={{ fontSize: "15x", fontWeight: "bold", textAlign: "center", margin: "4px 0" }}>
                                    Dwell(sec) = {" "}
                                    <strong style={{ color: "green", fontSize: "17px" }}>
                                      {item.avgdwell}
                                    </strong>
                                  </p>
                                  <p style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", margin: "4px 0" }}>
                                    Engaged = {" "}
                                    <strong style={{ color: "green", fontSize: "17px" }}>
                                      {item.engaged}
                                    </strong>
                                  </p>
                                  <p style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", margin: "4px 0" }}>
                                    Bounced = {" "}
                                    <strong style={{ color: "green", fontSize: "17px" }}>
                                      {item.bounced}
                                    </strong>
                                  </p>
                                </>
                              )}
                            </Card>
                          </Col>
                        ))
                      ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: "16px", color: "gray" }}>
                            No Store Data Available
                          </Text>
                        </div>
                      )
                    }
                  </Row> :
            ingressLive && dwellLive ?
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row gutter={[20, 20]}>
                  <Col xs={24} sm={24} md={24} lg={15} xl={16}>
                    <Row gutter={[20, 20]}>
                      <Col xs={24} sm={24} md={24} lg={12} xl={9}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "auto",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Footfall
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: "6rem",
                            }}
                          >
                            <Col>
                              <Title
                                level={1}
                                style={{
                                  fontWeight: "normal",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                }}
                              >
                                {totalingress !== null && totalingress !== undefined
                                  ? totalingress
                                  : 0}
                              </Title>
                              <Text style={{ backgroundColor: "#abd1b5" }}>
                                {totalingrespercentage !== null && totalingrespercentage !== undefined
                                  ? totalingrespercentage > 100
                                    ? "100"
                                    : totalingrespercentage
                                  : 0}
                                %
                              </Text>
                              <Text> Vs.PreviousDay</Text>
                            </Col>
                            <Col>
                              <GiFootsteps size={70} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12} xl={15}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "auto",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Peak Hours
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: window.innerHeight > 850 ? "6rem" : "auto",
                            }}
                          >
                            <Col>
                              <Text
                                style={{
                                  fontWeight: "bold",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                  fontSize: "29px",
                                }}
                              >
                                {peakHour !== null && peakHour !== undefined && peakHour !== "Invalid date - Invalid date"
                                  ? peakHour
                                  : "- -"}
                              </Text>
                              <Text>
                                Yesterday's Peak Hours{" "}
                                {yesterdaypeakHour !== null && yesterdaypeakHour !== undefined &&
                                  yesterdaypeakHour !== "Invalid date - Invalid date"
                                  ? yesterdaypeakHour
                                  : "- -"}
                              </Text>
                            </Col>
                            <Col>
                              <ImHourGlass size={60} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>

                    </Row>
                    <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                      <Col xs={24} sm={24} md={24} lg={7} xl={9}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "190px",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                  Live Occupancy
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          <Col
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "2rem",
                              height: "3rem",
                            }}
                          >
                            <Col>
                              <Title
                                level={1}
                                style={{
                                  fontWeight: "normal",
                                  margin: 0,
                                  padding: "5px",
                                  fontFamily: "Helvetica",
                                }}
                              >
                                {totalLiveOccupancyCount}
                              </Title>
                            </Col>
                            <Col>
                              <GiTeamUpgrade size={60} />
                            </Col>
                          </Col>
                        </Card>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={17} xl={15}>
                        <Card
                          className="ingress-hover"
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "190px",
                          }}
                          title={
                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Title
                                type="secondary"
                                level={5}
                                style={{ fontFamily: "Helvetica" }}
                              >
                                Total Onboard Camera :
                                <span style={{ marginLeft: "7px" }}>
                                  {totalfootfallactivecamera}
                                </span>
                              </Title>
                              <div>
                                <GiCctvCamera size={40} />
                              </div>
                            </Row>
                          }
                        >
                          <Row gutter={[16, 16]} justify="center">
                            {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                              eventbasedactivecamera.map((item, index) => (
                                <Col key={index} xs={24} sm={12} md={8} style={{ height: "7rem" }}>
                                  <Card
                                    style={{
                                      textAlign: "center",
                                      borderRadius: "8px",
                                      height: "100px",
                                    }}
                                  >
                                    <Title
                                      level={5}
                                      style={{
                                        fontFamily: "Helvetica",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    >
                                      {item.eventName}
                                    </Title>
                                    <Text
                                      type="secondary"
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "10px",
                                        display: "block",
                                      }}
                                    >
                                      Active Cameras: {item.cameraCount}
                                    </Text>
                                  </Card>
                                </Col>
                              ))}
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={9} xl={8}>
                    <Row gutter={[20, 20]} >
                      <Col xs={24}>
                        <Card
                          style={{
                            overflowY: "scroll",
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "440px"
                          }}
                          styles={{
                            body: {
                              // minHeight: "150px",
                              maxHeight: "860px",
                              overflowY: "scroll",
                            },
                          }}
                          title={
                            <Row
                              justify={"space-between"}
                              align={"middle"}
                            >
                              <Col>
                                <Title type="secondary" level={5}>
                                  {"Crowd Analysis - " + totalCrowdAnalysisCount}
                                </Title>
                              </Col>
                              <Col>
                                <LiveTag />
                              </Col>
                            </Row>
                          }
                        >
                          <List
                            itemLayout="horizontal"
                            dataSource={data}
                            renderItem={(item, index) => (
                              <List.Item>
                                <List.Item.Meta
                                  avatar={
                                    <Avatar
                                      icon={
                                        <FaCameraRetro
                                          style={{ color: "blue" }}
                                        />
                                      }
                                    />
                                  }
                                  title={
                                    <Row>
                                      <Col span={19}>
                                        <Text
                                          strong
                                          style={{
                                            fontSize: "17px",
                                            marginRight: "72px",
                                          }}
                                        >
                                          {item.cameraName}
                                        </Text>
                                      </Col>
                                      <Col span={3}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent:
                                              "space-between",
                                          }}
                                        >
                                          {/* {item.trent >= 0 ? (
                                            <Tag color="blue">
                                              <ArrowUpOutlined />{" "}
                                              {Math.abs(item.trent)}%
                                            </Tag>
                                          ) : (
                                            <Tag color="red">
                                              <ArrowDownOutlined />{" "}
                                              {Math.abs(item.trent)}%
                                            </Tag>
                                          )} */}
                                        </div>
                                      </Col>
                                    </Row>
                                  }
                                  description={
                                    <div>
                                      {item.count} people Captured
                                    </div>
                                  }
                                />
                              </List.Item>
                            )}
                          />
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {ingresscameras > 1 ?
                    <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card
                          loading={ingressloading}
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "22rem",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                  Entry Wise FootFall
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          {EntryWiseBarData.series && EntryWiseBarData.series.length > 0 ? (
                          <div className="app">
                            <div className="row">
                              <div style={{ width: "100%", overflowX: "auto" }}>
                                <div style={{ width: `${EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}px`, minWidth: "600px" }}>
                                  <div className="mixed-chart">
                                    <ReactApexChart
                                      type="bar"
                                      options={EntryWiseBarData.options}
                                      series={EntryWiseBarData.series}
                                      height="170%"
                                      width={EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          ) : (
                            <div style={{ textAlign: "center", padding: "20px" }}>
                              <Text style={{ fontSize: "16px", color: "gray" }}>
                                No Data Available
                              </Text>
                            </div>
                          )}
                        </Card>
                      </Col>
                    </Row> : <></>
                }

                <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Card
                      loading={ingressloading}
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        boxShadow: "none",
                        height: "20rem",
                      }}
                      title={
                        <Row justify={"space-between"} align={"middle"}>
                          <Col>
                            <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                              Ingress Counts per Hour
                            </Title>
                          </Col>
                        </Row>
                      }
                    >
                      {chartData.series && chartData.series.length > 0 ? (
                        <div className="app">
                          <div className="row">
                            <div className="mixed-chart">
                              <ReactApexChart
                                options={chartData.options}
                                series={chartData.series}
                                type="area"
                                height="150%"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: "16px", color: "gray" }}>
                            No Data Available
                          </Text>
                        </div>
                      )}
                    </Card>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Row gutter={[20, 20]}>
                  <Col xs={24}>
                    <Card
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        boxShadow: "none",
                        height: "370px",
                      }}
                      title={
                        <Row justify={"space-between"} align={"middle"}>
                          <Col>
                            <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                              Dwell Time
                            </Title>
                          </Col>
                        </Row>
                      }
                    >
                       <Skeleton loading={graphLoading}>
                      <ReactApexChart
                        options={DwellHourlyDateWise.options}
                        series={DwellHourlyDateWise.series}
                        type="bar"
                        height="auto"
                      />
                    </Skeleton>
                    </Card>
                  </Col>
                </Row>
              </Col> */}
                </Row>

                {dwellcameras > 1 ? <EngageAndBounceCamera /> : <></>}

                <Row gutter={[20, 20]} style={{ marginTop: "1rem", justify: "space-between", align: "middle" }} >
                  <EngageAndBounce />
                </Row>                 

                <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Card
                      loading={ingressloading}
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        boxShadow: "none",
                        height: "20rem",
                      }}
                      title={
                        <Row justify={"space-between"} align={"middle"}>
                          <Col>
                            <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                              Avg Dwell Time Per Hour
                            </Title>
                          </Col>
                        </Row>
                      }
                    >
                      {DwellBarData.series && DwellBarData.series.length > 0 ? (
                        <div className="app">
                          <div className="row">
                            <div className="mixed-chart">
                              <ReactApexChart
                                type="bar"
                                options={DwellBarData.options}
                                series={DwellBarData.series}
                                height="150%"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: "16px", color: "gray" }}>
                            No Data Available
                          </Text>
                        </div>
                      )}
                    </Card>
                  </Col>
                </Row>

              </Col>
              :
              ingressLive ?
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Row gutter={[20, 20]}>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "auto",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                    Footfall
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            <Col
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2rem",
                                height: "6rem",
                              }}
                            >
                              <Col>
                                <Title
                                  level={1}
                                  style={{
                                    fontWeight: "normal",
                                    margin: 0,
                                    padding: "5px",
                                    fontFamily: "Helvetica",
                                  }}
                                >
                                  {totalingress !== null && totalingress !== undefined
                                    ? totalingress
                                    : 0}
                                </Title>
                                <Text style={{ backgroundColor: "#abd1b5" }}>
                                  {totalingrespercentage !== null && totalingrespercentage !== undefined
                                    ? totalingrespercentage > 100
                                      ? "100"
                                      : totalingrespercentage
                                    : 0}
                                  %
                                </Text>
                                <Text> Vs.PreviousDay</Text>
                              </Col>
                              <Col>
                                <GiFootsteps size={70} />
                              </Col>
                            </Col>
                          </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "auto",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                    Peak Hours
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            <Col
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2rem",
                                height: window.innerHeight > 850 ? "6rem" : "auto",
                              }}
                            >
                              <Col>
                                <Text
                                  style={{
                                    fontWeight: "bold",
                                    margin: 0,
                                    padding: "5px",
                                    fontFamily: "Helvetica",
                                    fontSize: "29px",
                                  }}
                                >
                                  {peakHour !== null && peakHour !== undefined && peakHour !== "Invalid date - Invalid date"
                                    ? peakHour
                                    : "- -"}
                                </Text>
                                <Text>
                                  Yesterday's Peak Hours{" "}
                                  {yesterdaypeakHour !== null && yesterdaypeakHour !== undefined &&
                                    yesterdaypeakHour !== "Invalid date - Invalid date"
                                    ? yesterdaypeakHour
                                    : "- -"}
                                </Text>
                              </Col>
                              <Col>
                                <ImHourGlass size={60} />
                              </Col>
                            </Col>
                          </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "230px",
                            }}
                            title={
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Title
                                  type="secondary"
                                  level={5}
                                  style={{ fontFamily: "Helvetica" }}
                                >
                                  Total Onboard Camera :
                                  <span style={{ marginLeft: "7px" }}>
                                    {totalfootfallactivecamera}
                                  </span>
                                </Title>
                                <div>
                                  <GiCctvCamera size={40} />
                                </div>
                              </Row>
                            }
                          >
                            <Row gutter={[16, 16]} justify="center">
                              {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                                eventbasedactivecamera.map((item, index) => (
                                  <Col key={index} xs={24} sm={12} md={12} lg={12} xl={12}>
                                    <Card
                                      style={{
                                        textAlign: "center",
                                        borderRadius: "8px",
                                        height: "100px",
                                        margin: "0 auto",
                                      }}
                                    >
                                      <Title
                                        level={5}
                                        style={{
                                          fontFamily: "Helvetica",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      >
                                        {item.eventName}
                                      </Title>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "10px",
                                          display: "block",
                                        }}
                                      >
                                        Active Cameras: {item.cameraCount}
                                      </Text>
                                    </Card>
                                  </Col>
                                ))}
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {ingresscameras > 1 ?
                    <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card
                          loading={ingressloading}
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            boxShadow: "none",
                            height: "22rem",
                          }}
                          title={
                            <Row justify={"space-between"} align={"middle"}>
                              <Col>
                                <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                  Entry Wise FootFall
                                </Title>
                              </Col>
                            </Row>
                          }
                        >
                          {EntryWiseBarData.series && EntryWiseBarData.series.length > 0 ? (
                            <div className="app">
                              <div className="row">
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                  <div style={{ width: `${EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}px`, minWidth: "600px" }}>
                                    <div className="mixed-chart">
                                      <ReactApexChart
                                        type="bar"
                                        options={EntryWiseBarData.options}
                                        series={EntryWiseBarData.series}
                                        height="170%"
                                        width={EntryWiseBarData.series[0].data.length > 10 ? ((EntryWiseBarData.series[0].data.length - 10) * 210) + (35 * 60) : 35 * 60}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div style={{ textAlign: "center", padding: "20px" }}>
                              <Text style={{ fontSize: "16px", color: "gray" }}>
                                No Data Available
                              </Text>
                            </div>
                          )}
                        </Card>
                      </Col>
                    </Row> : <></>
                  }

                  <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Card
                        loading={ingressloading}
                        style={{
                          cursor: "pointer",
                          userSelect: "none",
                          boxShadow: "none",
                          height: "20rem",
                        }}
                        title={
                          <Row justify={"space-between"} align={"middle"}>
                            <Col>
                              <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                Ingress Counts per Hour
                              </Title>
                            </Col>
                          </Row>
                        }
                      >
                        {chartData.series && chartData.series.length > 0 ? (
                          <div className="app">
                            <div className="row">
                              <div className="mixed-chart">
                                <ReactApexChart
                                  options={chartData.options}
                                  series={chartData.series}
                                  type="area"
                                  height="150%"
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <Text style={{ fontSize: "16px", color: "gray" }}>
                              No Data Available
                            </Text>
                          </div>
                        )}
                      </Card>
                    </Col>
                  </Row>
                </Col> :
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={15} xl={16}>
                      <Row gutter={[20, 20]}>
                        <Col xs={24} sm={24} md={24} lg={7} xl={9}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "190px",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica" }}>
                                    Live Occupancy
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            <Col
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2rem",
                                height: "3rem",
                              }}
                            >
                              <Col>
                                <Title
                                  level={1}
                                  style={{
                                    fontWeight: "normal",
                                    margin: 0,
                                    padding: "5px",
                                    fontFamily: "Helvetica",
                                  }}
                                >
                                  {totalLiveOccupancyCount}
                                </Title>
                              </Col>
                              <Col>
                                <GiTeamUpgrade size={60} />
                              </Col>
                            </Col>
                          </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={17} xl={15}>
                          <Card
                            className="ingress-hover"
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "190px",
                            }}
                            title={
                              <Row
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Title
                                  type="secondary"
                                  level={5}
                                  style={{ fontFamily: "Helvetica" }}
                                >
                                  Total Onboard Camera :
                                  <span style={{ marginLeft: "7px" }}>
                                    {totalfootfallactivecamera}
                                  </span>
                                </Title>
                                <div>
                                  <GiCctvCamera size={40} />
                                </div>
                              </Row>
                            }
                          >
                            <Row gutter={[16, 16]} justify="center">
                              {eventbasedactivecamera && eventbasedactivecamera.length > 0 &&
                                eventbasedactivecamera.map((item, index) => (
                                  <Col key={index} xs={24} sm={12} md={8} style={{ height: "7rem" }}>
                                    <Card
                                      style={{
                                        textAlign: "center",
                                        borderRadius: "8px",
                                        height: "100px",
                                      }}
                                    >
                                      <Title
                                        level={5}
                                        style={{
                                          fontFamily: "Helvetica",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      >
                                        {item.eventName}
                                      </Title>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "10px",
                                          display: "block",
                                        }}
                                      >
                                        Active Cameras: {item.cameraCount}
                                      </Text>
                                    </Card>
                                  </Col>
                                ))}
                            </Row>
                          </Card>
                        </Col>
                      </Row>

                      <Row gutter={[20, 20]} style={{ marginTop: "1rem" }}>

                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                          <Card
                            loading={ingressloading}
                            style={{
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "20rem",
                            }}
                            title={
                              <Row justify={"space-between"} align={"middle"}>
                                <Col>
                                  <Title level={5} type="secondary" style={{ fontFamily: "Helvetica", textWrap: "wrap", width: "100%" }}>
                                    Avg Dwell Time Per Hour
                                  </Title>
                                </Col>
                              </Row>
                            }
                          >
                            {DwellBarData.series && DwellBarData.series.length > 0 ? (
                              <div className="app">
                                <div className="row">
                                  <div className="mixed-chart">
                                    <ReactApexChart
                                       type="bar"
                                       options={DwellBarData.options}
                                       series={DwellBarData.series}
                                       height="150%"
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div style={{ textAlign: "center", padding: "20px" }}>
                                <Text style={{ fontSize: "16px", color: "gray" }}>
                                  No Data Available
                                </Text>
                              </div>
                            )}                
                          </Card>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={9} xl={8}>
                      <Row gutter={[20, 20]} >
                        <Col xs={24}>
                          <Card
                            style={{
                              overflowY: "scroll",
                              cursor: "pointer",
                              userSelect: "none",
                              boxShadow: "none",
                              height: "526px"
                            }}
                            styles={{
                              body: {
                                // minHeight: "150px",
                                maxHeight: "860px",
                                overflowY: "scroll",
                              },
                            }}
                            title={
                              <Row
                                justify={"space-between"}
                                align={"middle"}
                              >
                                <Col>
                                  <Title type="secondary" level={5}>
                                    {"Crowd Analysis - " + totalCrowdAnalysisCount}
                                  </Title>
                                </Col>
                                <Col>
                                  <LiveTag />
                                </Col>
                              </Row>
                            }
                          >
                            <List
                              itemLayout="horizontal"
                              dataSource={data}
                              renderItem={(item, index) => (
                                <List.Item>
                                  <List.Item.Meta
                                    avatar={
                                      <Avatar
                                        icon={
                                          <FaCameraRetro
                                            style={{ color: "blue" }}
                                          />
                                        }
                                      />
                                    }
                                    title={
                                      <Row>
                                        <Col span={19}>
                                          <Text
                                            strong
                                            style={{
                                              fontSize: "17px",
                                              marginRight: "72px",
                                            }}
                                          >
                                            {item.cameraName}
                                          </Text>
                                        </Col>
                                        <Col span={3}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent:
                                                "space-between",
                                            }}
                                          >
                                            {/* {item.trent >= 0 ? (
                                              <Tag color="blue">
                                                <ArrowUpOutlined />{" "}
                                                {Math.abs(item.trent)}%
                                              </Tag>
                                            ) : (
                                              <Tag color="red">
                                                <ArrowDownOutlined />{" "}
                                                {Math.abs(item.trent)}%
                                              </Tag>
                                            )} */}
                                          </div>
                                        </Col>
                                      </Row>
                                    }
                                    description={
                                      <div>
                                        {item.count} people Captured
                                      </div>
                                    }
                                  />
                                </List.Item>
                              )}
                            />
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                   {dwellcameras > 1 ? <EngageAndBounceCamera /> : <></>}

                  <Row gutter={[20, 20]} style={{ marginTop: "1rem", justify: "space-between", align: "middle" }} >
                    <EngageAndBounce />
                  </Row>                  
                </Col>
          )
        )}
      </Row>
    </div>

  );
};

export default Live;
